import translation from "zod-i18n-map/locales/cs/zod.json";

export const CzechResourcesDictionary = {
  Common: {
    Other: "Ostatní",
    Age: "věk",
    AppName: "Analyzátor",
    Cancel: "Zrušit",
    SelectPlaceholder: "Vybrat",
    Close: "Zavřít",
    ConfirmClose: {
      Title: "Opravdu chcete zavřít?",
      Text: "Vyplněné údaje nebudou uloženy.",
      Confirm: "Zavřít bez uložení",
      Cancel: "Pokračovat v úpravách",
    },
    EnlargeImage: "Zvětšit obrázek",
    Child: "dítě",
    ChildrenMany: "dětí",
    Children: "děti",
    Confirm: "Potvrdit",
    Continue: "Pokračovat",
    Copy: "Kopírovat",
    Copied: "Zkopírováno",
    Create: "Vytvořit",
    Created: "Vytvořeno",
    Delete: "Smazat",
    Detail: "Detail",
    PersonalInfo: "Osobní údaje",
    Edit: "Upravit",
    Email: "E-mail",
    Phone: "Telefon",
    Address: "Adresa",
    Error: "Něco se pokazilo. Omlouváme se za komplikace. Zkuste to prosím znovu za chvíli.",
    Investment: "Investice",
    MoreInfo: "Více informací",
    Month: "měsíc",
    Monthly: "měsíčně",
    Yearly: "ročně",
    HalfYearly: "půlročně",
    HalfYear: "půlrok",
    QuarterYear: "čtvrtrok",
    Quarterly: "čtvrtletně",
    Months_few: "{{count}} měsíce",
    Months_one: "{{count}} měsíc",
    Months_other: "{{count}} měsíců",
    Months: "{{count}} měsíců",
    NewAnalysis: "Nová analýza",
    No: "Ne",
    Note: "Poznámka",
    Or: "nebo",
    CZKSuffix: "Kč",
    Resolve: "Vyřešit",
    Save: "Uložit",
    SaveAndClose: "Uložit a zavřít",
    Search: "Vyhledat",
    ClearSearch: "Vymazat hledání",
    Searching: "Vyhledávám...",
    SignOut: "Odhlásit se",
    Time: "čas",
    Total: "Celkem",
    UnsavedChanges_one: "neuložená změna",
    UnsavedChanges_few: "neuložené změny",
    UnsavedChanges_other: "neuložených změn",
    Items_one: "{{count}} položka",
    Items_few: "{{count}} položky",
    Items_other: "{{count}} položek",
    Value: "hodnota",
    Year: "rok",
    YearsFew: "roky",
    Years: "let",
    Points_one: "bod",
    Points_few: "body",
    Points_other: "bodů",
    FamilyMembers_one: "{{count}} člen",
    FamilyMembers_few: "{{count}} členové",
    FamilyMembers_other: "{{count}} členů",
    Yes: "Ano",
    LTV: "LTV",
    RemainingYears: "Zbývá let",
    RepayIn: "Splatit za",
    Pieces: "kusů",
    OneTime: "jednorázově",
  },
  Errors: {
    ContactUs: "V případě, že problémy přetrvávají, kontaktujte nás na emailu:",
    ApplicationError: {
      Title: "Nastala chyba",
      Subtitle: "Je nám líto v aplikaci došlo k chybě.",
      Home: "Domů",
    },
    Error404: {
      Title: "Stránka nebyla nalezena",
      Subtitle: "Požadováná stránka nebyla nalezena. Ověřte správnost URL zadané v adresním řádku prohlížeče.",
      Home: "Domů",
    },
    Error403: {
      Title: "Přístup odepřen",
      Subtitle: "K zobrazení této stránky nemáte přístupová práva.",
    },
    Error400SignIn: {
      Title: "Přihlášení se nezdařilo",
      Subtitle: "Během procesu autentizace vznikly chyby. Pokud problémy přetrvávají, kontaktujte: {{email}}.",
      Button: "Zkusit znovu",
    },
    ErrorAppAccess: {
      Title: "Přístup odepřen",
      Subtitle: "Pro přístup k nástroji Analyzátor je nutné mít akceptovaný podepsaný Profi dodatek.",
      Button: "Zkusit znovu",
    },
  },
  Dashboard: {
    Title: "Dashboard",
    Subtitle: "Vítejte zpátky",
    ActivityOverview: "Váš aktuální přehled aktivity.",
    ComparedToLastMonth: "vs. minulý měsíc",
    GraphInterval: {
      AllTime: "Celé období",
      TwelveMonths: "12 měsíců",
      SixMonths: "6 měsíců",
      ThirtyDays: "30 dní",
      SevenDays: "7 dní",
    },
  },
  AnalysesListing: {
    Title: "Přehled analýz",
    Subtitle: "Správa a přeheld vašich analýz.",
    Status: {
      All: "Všechny",
      InProgress: "Rozpracováno",
      Completed: "Dokončeno",
      Declined: "Nemá zájem",
      Shared: "Sdílené",
    },
    Table: {
      HeaderCell: {
        Client: "Klient",
        Family: "Rodina",
        Name: "Název",
        State: "Stav",
        DateCreated: "Vytvořeno",
        DateUpdated: "Aktualizováno",
        Access: "Přístup",
      },
      Access: {
        ListLabel: "Poradci s přístupem",
        Advisor: "{{advisorName}} ({{advisorId}})",
        Owner: "Vlastník analýzy",
        Current: "Aktuálně upravuje",
        Past: "Dříve pracoval(a)",
      },
      FamilyMembers: {
        Title: "Členové rodiny",
        Client: "Klient",
      },
      EmptyState: {
        ClearSearch: "Vyčistit hledání",
        NoResult: {
          Title: "Analýza nebyla nalezena",
          Message: "Vaše vyhledávání neodpovídá žádným kritériím. Zkuste to prosím znovu.",
        },
        NoResultWithQuery: {
          Message: `Vaše vyhledávání "{{value}}" neodpovídá žádným kritériím. Zkuste to prosím znovu.`,
        },
        NoData: {
          Title: "Zatím nemáte žádné analýzy",
          Message: `Vytvořte svou první analýzu kliknutím níže na akci "Nová analýza".`,
        },
      },
    },
    Toast: {
      NewVersion: "Nová verze analýzy byla vytvořena.",
      NewState: "Stav analýzy úspěšně změněn.",
    },
  },
  AnalysisDetail: {
    AnalysisOverview: "Přehled analýz",
    VersionSelect: {
      Tooltip: "Výběr verze analýzy",
      Trigger: "V. {{version}}",
      Older: "· starší",
      Label: "Verze analýzy",
      Latest: "Nejnovější verze",
      Previous: "Předchozí verze",
      Version: "Verze {{version}}",
    },
    Duplicate: {
      Action: "Duplikovat verzi analýzy",
      Duplicating: "Duplikuji analýzu…",
      Duplicated: "Analýza byla duplikována. Můžete ji upravovat.",
      Conflict: {
        Title: "Analýzu tohoto klienta už máte",
        Text: "Tuto analýzu jste už dříve duplikovali, nebo máte jinou analýzu stejného klienta. Kopie verze {{version}} vznikne jako nová verze vaší analýzy.",
        Confirm: "Vytvořit novou verzi",
        OpenExisting: "Otevřít analýzu",
      },
      ClosingLatest: {
        Title: "Vytvořit novou verzi z verze {{version}}?",
        Text: "Nová verze {{newVersion}} vznikne kopií verze {{version}}.",
        TextClosingLatest:
          "Nová verze {{newVersion}} vznikne kopií verze {{version}}. Rozpracovaná verze {{latestVersion}} se uzavře se stavem Nemá zájem.",
        Confirm: "Vytvořit novou verzi",
        Error: {
          CloseFailed: "Rozpracovanou verzi se nepodařilo uzavřít. Zkuste to znovu.",
          ClosedButNotCreated:
            "Verze {{latestVersion}} byla uzavřena se stavem Nemá zájem, ale novou verzi se nepodařilo vytvořit. Zkuste to znovu.",
          NotCreated: "Novou verzi se nepodařilo vytvořit. Zkuste to znovu.",
        },
      },
      Error: {
        InProgress: "Analýzu tohoto klienta máte rozpracovanou. Kopii lze vytvořit až po jejím uzavření.",
        SelfDealingForbidden: "Nelze duplikovat analýzu klienta, který má shodu v kontraktačních údajích s údaji poradce.",
        NsureAccountMissing: "Nemáte účet v nSure, duplikaci nelze provést.",
        MangoAccountMissing: "Váš účet se nepodařilo dohledat v MangoUp, duplikaci nelze provést.",
        HandedOver: "Analýzu právě spravuje jiný poradce, duplikovat ji můžete až po převzetí zpět.",
      },
    },
    Client: "Klient",
    DateCreated: "Vytvořeno",
    Agent: "Poradce",
    Pdf: {
      Loading: "Načítám dokument…",
      LoadError: "Nepodařilo se načíst dokument.",
    },
    InvestmentCase: {
      Creating: "Probíhá příprava analýzy…",
      Retry: "Zkusit znovu",
      LoadError: {
        Title: "Analýzu se nepodařilo načíst",
        Text: "Zkuste to prosím znovu. Pokud problémy přetrvávají, kontaktujte: {{email}}.",
      },
      CreateError: {
        Title: "Nepodařilo se založit investiční případ",
        Text: "Bez investičního případu nelze s analýzou pracovat. Zkuste to prosím znovu za chvíli. Pokud problémy přetrvávají, kontaktujte: {{email}}.",
        AgentNotFoundText:
          "K vašemu účtu se nepodařilo dohledat účet pro investiční případ, proto nelze v analýze pokračovat. Kontaktujte prosím: {{email}}.",
      },
    },
    Assets: {
      Subtitle: "Správa a sledování majetku rodiny klienta",
      EntryType: "Způsob zadání",
      AssetSummary: {
        Title: "Rekapitulace majetku",
        Immovable: "Nemovitý",
        Movable: "Movitý",
        Financial: "Finanční",
        Liabilities: "Závazky",
        Unusable: "Nevyužitelný",
        Available: "K dispozici",
        Assets: "Majetek",
      },
      Aggregated: "Souhrnně",
      Individual: "Jednotlivě",
      Value: "Cena",
      Name: "Název",
      Attributes: "Označení majetku",
      Insured: "Zajištěný",
      Usable: "Využitelný",
      Unusable: "Nevyužitelný",
      IsUsableForGoals: "Majetek je možné využít na cíle",
      IsCoveredByInsurance: "Majetek je pojištěn",
      IsUnderFinancing: "Majetek je financován (např. úvěrem)",
      Immovable: {
        ImmovableAssetType: {
          Title: "Typ majetku",
          House: "Dům",
          Apartment: "Byt",
          Cabin: "Chalupa/Chata",
          Land: "Pozemky",
          Forest: "Lesy",
          Other: "Jiné",
        },
        Title: "Nemovitý majetek",
        Add: "Přidat nemovitý majetek",
        Edit: "Upravit nemovitý majetek",
        Amount: "Hodnota",
        Deleted: "Nemovitý majetek úspěšně smazán.",
        Created: "Nemovitý majetek úspěšně vytvořen.",
        Edited: "Nemovitý majetek úspěšně upraven.",
        Error: "Chyba při ukládání nemovitého majetku.",
      },
      Movable: {
        MovableAssetType: {
          Title: "Typ majetku",
          Vehicle: "Auto",
          Company: "Firma",
          Other: "Jiné",
        },
        Title: "Movitý majetek",
        Add: "Přidat movitý majetek",
        Amount: "Hodnota",
        Edit: "Upravit movitý majetek",
        Deleted: "Movitý majetek úspěšně smazán.",
        Created: "Movitý majetek úspěšně vytvořen.",
        Edited: "Movitý majetek úspěšně upraven.",
        Error: "Chyba při ukládání movitého majetku.",
      },
      Financial: {
        FinancialAssetType: {
          Cash: "Hotovost",
          BankAccount: "Běžný účet",
          SavingAccount: "Spořící účet",
          BuildingSaving: "Stavební spoření",
          PensionSaving: "Penzijní produkty",
          Investment: "Investiční nástroje",
          Title: "Typ majetku",
          Vehicle: "Vozidlo",
          Company: "Společnost",
          Other: "Jiné",
        },
        Title: "Finanční majetek",
        Add: "Přidat finanční majetek",
        Amount: "Hodnota",
        Edit: "Upravit finanční majetek",
        Deleted: "Finanční majetek úspěšně smazán.",
        Created: "Finanční majetek úspěšně vytvořen.",
        Edited: "Finanční majetek úspěšně upraven.",
        Error: "Chyba při ukládání finančního majetku.",
        Value: "Hodnota majetku",
        RegisteredExpenses: "Evidované výdaje",
        BelongsTo: "Patří k",
        Insitution: "Instituce",
      },
      Liabilities: {
        LiabilityType: {
          Title: "Typ závazku",
          Mortgage: "Hypotéka",
          BuildingSaving: "Úvěr ze StSp",
          Consumer: "Spotřebitelský úvěr",
          CreditCard: "Kreditní karta",
          Overdraft: "Kontokorent",
          Other: "Jiné",
        },
        LiabilityTypePlural: {
          Mortgage: "Hypotéky",
          BuildingSaving: "Úvěry ze StSp",
          Consumer: "Spotřebitelské úvěry",
          CreditCard: "Kreditní karty",
          Overdraft: "Kontokorenty",
          Other: "Jiné",
        },
        Title: "Závazky",
        Add: "Přidat závazek",
        Amount: "Hodnota",
        Edit: "Upravit závazek",
        Deleted: "Závazek úspěšně smazán.",
        Created: "Závazek úspěšně vytvořen.",
        Edited: "Závazek úspěšně upraven.",
        Error: "Chyba při ukládání závazku.",
        Value: "Hodnota závazku",
        RegisteredExpenses: "Evidované výdaje",
        BelongsTo: "Patří k",
        Insitution: "Instituce",
        DueDate: "Datum splatnosti",
        DeleteLiabilityWithLoanExpense: "Včetně výdaje",
        DeleteLiabilityWithoutLoanExpense: "Pouze závazek",
      },
      ModelingModal: {
        Title: "Potvrzení změny",
        Body: "Opravdu si přejete provést tuto změnu? Upozorňujeme, že tímto krokem dojde k vymazání přiřazeného majetku v modelaci. Pokračováním souhlasíte s odstraněním těchto dat a nelze je vrátit zpět.",
      },
    },
    AssetsAndContracts: {
      Title: "Majetek a smlouvy",
      Subtitle: "Správa majetku a souvisejících smluv.",
      AddCurrentSolution: "Přidat stávající řešení",
      AddAsset: "Přidat majetek",
      ImmovableAsset: "Nemovitý majetek",
      MovableAsset: "Movitý majetek",
      AddContract: "Přidat smlouvu",
      AddAnotherRisk: "Přidat riziko",
      EditExistingContract: "Upravit stávající smlouvu",
      EditNewContract: "Upravit novou smlouvu",
      InsuranceValue: "Pojistná hodnota",
      CurrentInsurance: "Stávající pojištění",
      ProposedSolution: "Navrhované řešení",
      ProposedSolutionStepTypes: {
        Keep: "Zachovat současné",
        CreateRecommended: "Zasmluvnit doporučené",
        Modify: "Upravit současné",
      },
      ProposedSolutionStepTypesShort: {
        Keep: "Zachovat",
        CreateRecommended: "Zasmluvnit",
        Modify: "Upravit",
        Cancel: "Zrušit",
      },
      Form: {
        AddCoverage: "Další typ krytí",
        Area: "Plocha",
        AssetCreateSuccess: "Vytvoření majetku proběhlo úspěšně.",
        AssetEditSuccess: "Editace majetku proběhla úspěšně.",
        AssetDeleteSuccess: "Smazání majetku proběhlo úspěšně.",
        BasementArea: "Plocha sklepa",
        BusinessSector: "Obor podnikání",
        CompanyIdentificationNumber: "IČO",
        ContractAnniversaryDate: "Datum výročí smlouvy",
        ContractEditSuccess: "Editace smlouvy proběhla úspěšně",
        ContractCreateSuccess: "Vytvoření smlouvy proběhlo úspěšně.",
        ContractDeleteSuccess: "Smazání smlouvy proběhlo úspěšně.",
        DeleteContractTitle: "Smazat smlouvu",
        DeleteContractText: "Opravdu chcete smlouvu smazat?",
        DeleteAssetTitle: "Smazat majetek",
        DeleteAssetText: "Opravdu chcete majetek smazat? Smažou se i všechny jeho smlouvy.",
        CoverageAmount: "Výše krytí",
        CoverageType: "Typ krytí",
        PropertyInsuranceCoverage: "Nemovitost",
        HouseholdInsuranceCoverage: "Domácnost",
        OutbuildingCoverage: "Vedlejší stavby",
        OwnerLiabilityCoverage: "Odpovědnost z držby",
        LiabilityCoverage: "Odpovědnost",
        VehicleCompulsoryInsuranceCoverage: "Limit POV",
        VehicleCascoInsuranceCoverage: "Havarijní",
        VehicleOtherInsuranceCoverage: "Jiné",
        VehicleAssistanceInsuranceCoverage: "Asistence",
        VehicleWindscreenInsuranceCoverage: "Sklo",
        CurrentAmount: "Současná částka",
        RecommendedAmount: "Doporučená částka",
        CurrentCoverageAriaLabel: "{{coverage}} – současné pojištění",
        RecommendedCoverageAriaLabel: "{{coverage}} – doporučené pojištění",
        Underinsurance: "Podpojištění",
        FloorCount: "Počet nadzemních podlaží",
        Frequency: "Frekvence",
        HouseholdInsuranceAmount: "Pojistná hodnota domácnosti",
        InsuranceAmount: "Výše pojistného",
        LoadFromExistingExpenses: "Načíst ze stávajících výdajů",
        Name: "Název",
        Note: "Poznámka",
        NthFloorArea: "Plocha {{count}}. NP",
        OtherFloorArea: "Plocha ostatních podlaží",
        PropertyInsuranceAmount: "Pojistná hodnota nemovitosti",
        VehicleLicencePlate: "RZ/SPZ",
        VehiclePrice: "Cena vozidla",
        VIN: "VIN vozidla",
        Partner: "Partner",
        ProposedSolutionSteps: "Navrhované kroky řešení",
        ProposedSolution: "Způsob řešení",
        NewPartner: "Nový partner",
        InsuranceParameters: "Parametry pojištění",
        Parameter: "Parametr",
        Product: "Produkt",
      },
    },
    ClientResult: {
      PdfResult: {
        Title: "Výstupní dokumenty analýzy",
        Subtitle: "Vygenerujte dokument PDF pro sebe a Vašeho klienta, který shrnuje celou analýzu.",
        Preview: "Náhled dokumentu",
        ShareWithClient: "Možnosti sdílení s klientem",
        GeneratePdf: "Náhled PDF",
        Email: {
          Send: "Odeslat PDF na email klienta",
          Sent: "PDF výstup byl odeslán na email klientovi",
          EmailInvalid: "Email není možné odeslat. Zkontrolujte prosím emailovou adresu klienta.",
          EmailSentAt: "Odesláno {{date}}",
          EmailSending: "Odesílání",
          Confirm: {
            Title: "Odeslat PDF",
            Text: "Opravdu chcete odeslat PDF výstup analýzy klientovi na email: {{email}} ?",
          },
        },
        MobileApp: {
          Enable: "Zpřístupnit v mobilní aplikaci Šanon",
          Enabled: "PDF výstup byl zpřístupněn v mobilní aplikaci Šanon",
          EnabledAt: "Dostupné od {{date}}",
          Processing: "Probíhá příprava",
          Confirm: {
            Title: "Zpřístupnit PDF",
            Text: "Opravdu chcete zpřístupnit PDF klientovi v aplikaci Šanon?",
          },
          ClientNotFound: "Akce se nepodařila. Klient pravděpodobně nepoužívá mobilní aplikaci Šanon.",
          NotContactPerson: "Zveřejnit finanční plán do aplikace Šanon může klientovi pouze jeho kontaktní osoba.",
        },
      },
    },
    Tab: {
      ClientAnalysis: "Analýza klienta",
      FinancialAnalysis: "Finanční analýza",
      ClientResult: "Výstup pro klienta",
    },
    TabMenu: {
      Family: "Rodina",
      Goals: "Cíle",
      InvestmentQuestionnaire: "Investiční dotazník",
      Budget: "Rozpočet",
      Assets: "Majetek",
      Insurance: "Pojištění",
      GoalsFulfillment: "Plnění cílů",
      WealthAndAgreements: "Majetek a smlouvy",
      Modeling: "Modelace",
      ResultDocuments: "Výstupní dokumenty",
    },
    Family: {
      AddMemberOwnerOnly: "Člena rodiny může přidat pouze vlastník analýzy.",
      Form: {
        FirstName: "Jméno",
        LastName: "Příjmení",
        MemberType: "Typ člena rodiny",
        MemberTypes: {
          Adult: "Dospělá osoba",
          Child: "Dítě",
          PlannedChild: "Plánované dítě",
        },
      },
      MemberDrawer: {
        EditClientTitle: "Upravit klienta",
        EditFamilyMemberTitle: "Upravit člena rodiny",
        AddFamilyMemberTitle: "Přidat člena rodiny",
      },
    },
    Toast: {
      GoalCreated: "Cíl úspěšně vytvořen.",
      GoalUpdated: "Cíl úspěšně upraven.",
      GoalError: "Chyba při vytváření cíle",
      ActionError: "Chyba při provádění akce",
      InvestmentCaseRejected: "Investiční případ byl odmítnut. Navržená řešení byla automaticky odstraněna.",
      GrowUpRedirectError: "Nepodařilo se přejít na GrowUp.",
      FamilyMemberDeleted: "Člen rodiny úspěšně smazán.",
      FamilyMemberDeleteError: "Člena rodiny se nepodařilo smazat.",
      NoteSaved: "Poznámka uložena.",
      PensionPreviewError: "Nepodařilo se přepočítat rentu. Zkuste hodnotu zadat znovu.",
      NewVersionCreated: "Vytvořena nová verze {{version}}. Můžete ji upravovat.",
    },
    StatusBar: {
      SharedWithOther: {
        Title: "Jen pro čtení – analýzu právě upravuje {{advisorName}} ({{advisorId}}).",
        Text: "Pro úpravy ji převezměte.",
      },
      SharedWithMe: {
        Title: "Analýzu vám předal(a) {{ownerName}}.",
        Text: "Můžete ji upravovat. Až budete hotovi, vraťte ji poradci.",
        ReadOnlyText: "Až budete hotovi, vraťte ji poradci.",
      },
      Declined: {
        Title: "Jen pro čtení – klient nemá zájem.",
      },
      Completed: {
        Title: "Jen pro čtení – analýza je dokončená.",
      },
      ReadOnlyText: "Pro další úpravy vytvořte novou verzi.",
      ReturnToAdvisor: "Vrátit poradci",
      CreateNewVersion: "Vytvořit novou verzi",
    },
    WriteForbidden: {
      ReadOnlyAccess: {
        Title: "Analýzu už nemůžete upravovat",
        Text: "Mezitím vám byl odebrán přístup k úpravám analýzy, vaše poslední změna se proto neuložila. Po obnovení stránky uvidíte aktuální stav analýzy.",
      },
      NotEditable: {
        Title: "Analýzu už nelze upravovat",
        Text: "Analýza mezitím přestala být rozpracovaná, vaše poslední změna se proto neuložila. Po obnovení stránky uvidíte aktuální stav analýzy.",
      },
      Reload: "Obnovit stránku",
    },
    Note: {
      Title: "Interní poznámka",
      Tooltip: "Interní poznámka",
      Hint: "Interní poznámka se nepropisuje do žádného výstupu pro klienta, vidíte ji jenom vy.",
      SharedHint:
        "Interní poznámka se nepropisuje do žádného výstupu pro klienta. Vidí ji všichni poradci s přístupem k analýze, upravovat ji může ten, kdo analýzu právě edituje.",
    },
    MoreActions: {
      Title: "Další akce",
    },
    Sharing: {
      Title: "Nastavení přístupu k analýze",
      Subtitle: "{{analysisName}} · V. {{version}}",
      CurrentlySharedWith: "Aktuálně předáno",
      NotShared: {
        Title: "Analýza není nikomu předaná",
        Text: "Vyberte poradce v seznamu níže tlačítkem Předat.",
      },
      SharedWith: "Poradci k předání",
      SingleShareNote: "Analýzu lze předat vždy jen jednomu poradci. Pro předání jinému poradci ji nejdříve převezměte.",
      LoadError: "Seznam poradců se nepodařilo načíst.",
      NoAdvisors: {
        Title: "Zatím žádní poradci",
        Text: "Přidejte poradce podle čísla VZ a pak mu můžete analýzu předat.",
      },
      AdvisorId: "Poradce ({{advisorId}})",
      LatestVersionOnly: "Přístup lze nastavit jenom u nejnovější verze analýzy.",
      Share: "Předat",
      ShareDisabledTooltip: "Nejdříve analýzu převezměte",
      Shared: "Předáno",
      TakeOver: "Převzít",
      Remove: "Odebrat ze seznamu",
      AddAdvisor: {
        Title: "Přidat poradce",
        Placeholder: "Napište číslo VZ",
        Add: "Přidat",
        NotFound: "Poradce nebyl nalezen.",
        InList: "Již v seznamu",
        CannotAddSelf: "Sami sebe přidat nemůžete.",
        LimitReached: "V seznamu poradců k předání může být nejvýše {{max}} poradců. Pro přidání dalšího je nutné některého odebrat.",
      },
      Confirm: {
        Share: {
          Title: "Předat analýzu?",
          Text: "Analýzu bude upravovat poradce {{advisorName}} ({{advisorId}}), vy ji do převzetí uvidíte jen pro čtení.",
        },
        TakeBack: {
          Title: "Převzít analýzu?",
          Text: "Analýzu teď upravuje poradce {{advisorName}} ({{advisorId}}). Po převzetí ji poradce uvidí jen pro čtení a upravovat ji budete zase vy.",
        },
        Return: {
          Title: "Vrátit analýzu poradci?",
          Text: "Analýzu vrátíte poradci {{ownerName}}. Poté ji uvidíte už jen pro čtení.",
        },
        Remove: {
          Title: "Odebrat poradce ze seznamu?",
          Text: "Poradce {{advisorName}} ({{advisorId}}) zmizí ze seznamu poradců k předání u všech vašich analýz. Znovu ho můžete přidat podle čísla VZ.",
          Confirm: "Odebrat",
        },
      },
      Toast: {
        Shared: "Analýzu jste předali poradci.",
        TakenBack: "Analýzu jste převzali zpět.",
        ShareNsureAccountMissing: "Poradce {{advisorName}} nemá účet v nSure, předání editace nelze provést.",
        TakeBackNsureAccountMissing: "Nemáte účet v nSure, převzetí editace nelze provést.",
        Returned: "Analýzu jste vrátili poradci.",
        ReturnNsureAccountMissing: "Vlastník analýzy nemá účet v nSure, vrácení editace nelze provést.",
      },
    },
    ReportIssue: {
      Title: "Nahlásit problém",
      Hint: "Spolu s hlášením budou automaticky odeslány údaje o poradci, analýze a prohlížeči.",
      Description: "Popis problému",
      DescriptionPlaceholder: "Popište, co se stalo, co jste dělali před tím, než problém nastal, a co jste očekávali.",
      Submit: "Odeslat",
      Attachments: {
        Title: "Přidat přílohy",
        Description:
          "Max. {{count}} obrázky nebo videa. Obrázek do {{imageSize}} MB, video do {{videoSize}} MB, celkem do {{totalSize}} MB.",
        Remove: "Odebrat přílohu",
        Errors: {
          TooMany: "Můžete přidat maximálně {{count}} přílohy.",
          InvalidType: "Soubor {{name}} není podporovaný. Povolené jsou obrázky (PNG, JPG, WEBP) a videa (MP4, WEBM, MOV).",
          ImageTooLarge: "Obrázek {{name}} je větší než {{size}} MB.",
          VideoTooLarge: "Video {{name}} je větší než {{size}} MB.",
          TotalTooLarge: "Celková velikost příloh nesmí přesáhnout {{size}} MB.",
        },
      },
      Sent: {
        Title: "Hlášení odesláno",
        Text: "Děkujeme, na problém se podíváme co nejdříve.",
      },
      Error: {
        Title: "Hlášení se nepodařilo odeslat",
        Text: "Zkuste to prosím znovu za chvíli.",
        Retry: "Zkusit znovu",
      },
    },
    Goals: {
      AddGoal: "Přidat cíl",
      LockedAlert: "Cíle již není možné upravovat. Pro úpravu cílů je nutné vytvořit novou verzi analýzy.",
      AddExistingChild: "Přidat dítě",
      Amount: "Částka",
      WithdrawalIn: "Čerpání za",
      ChildLifePhases: {
        Title: "Životní fáze dítěte",
        EarlyAge: "Raný věk (0 - 6 let)",
        EarlyAgeDescription: "V raném dětství zahrnují náklady plenky, dětskou výživu, oblečení a zdravotní péči.",
        PrimarySchool: "Základní škola (6 - 15 let)",
        PrimarySchoolDescription: "Na základní škole se přidávají výdaje na školní potřeby, obědy, kroužky a oblečení.",
        HighSchool: "Střední škola (15 - 18 let)",
        HighSchoolDescription: "V dospívání stoupají náklady na dopravu, koníčky, oblečení a elektroniku.",
        University: "Vysoká škola (18+ let)",
        UniversityDescription: "Na vysoké škole jsou hlavními položkami školné, učebnice, ubytování a strava.",
        StartToLife: "Start do života",
        StartToLifeDescription: "Náklady mohou zahrnovat výdaje na podporu bydlení a základní potřeby.",
      },
      GoalName: "Název cíle",
      GoalNote: "Poznámka k cíli",
      GoalPriorityLabel: "Prioritní cíl",
      VehicleValue: "Očekávaná cena auta",
      IncludeInflation: "Zahrnout inflaci",
      IncludeFee: "Zahrnout poplatek",
      Fee: "Poplatek",
      IncludeEntryFee: "Zahrnout vstupní poplatek",
      InvestmentValue: "Hodnota investice",
      ShortTermInterestRate: "Krátkodobé zhodnocení",
      MidTermInterestRate: "Střednědobé zhodnocení",
      LongTermInterestRate: "Dlouhodobé zhodnocení",
      InterestRate: "Zhodnocení",
      InflationRate: "Inflace",
      InvestmentDuration: "Doba investování",
      InfinitePension: "Nekonečná renta",
      IncludeStatePension: "Počítat se starobním důchodem",
      MonthlyContribution: "Měsíční investice",
      NewGoal: "Nový cíl",
      EditGoal: "Upravit cíl",
      PurchaseDate: "Datum pořízení",
      Subtitle: "Efektivní sledování individuálních cílů.",
      Title: "Cíle klienta",
      Modeling: "Nastavení modelace",
      DrawType: "Frekvence čerpání",
      LumpSum: "Jednorázová",
      LoanAmount: "Výše úvěru",
      LoanInterestRate: "Úroková sazba úvěru",
      LoanDuration: "Splatnost",
      LoanPayment: "Splátka úvěru",
      LoanPaymentAct: "Splácení úvěru",
      NeededToSaveUp: "Musíte našetřit",
      MonthlyIncome: "Měsíční příjem",
      Income: "Příjem",
      Difference: "Rozdíl",
      Pension: "Důchod",
      NetIncome: "Čistá mzda",
      Monthly: "Měsíční",
      Months: "měsíců",
      DrawStart: "Počátek čerpání",
      DrawDuration: "Doba čerpání",
      DrawAmount: "Čerpaná částka",
      DrawDate: "Počátek čerpání",
      DrawdownInterestRate: "Zhodnocení při čerpání",
      PensionAccumulationInterestRate: "Zhodnocení při tvorbě renty",
      DrawProcess: "Čerpání renty",
      TargetAmount: "Cílová částka",
      CurrentEmergencyFundAmount: "Aktuální rezerva",
      CurrentSavingsAmount: "Aktuálně našetřeno",
      ExpectedPriceAmount: "Očekávaná kupní cena",
      TargetEmergencyFundAmount: "Požadovaná rezerva",
      TotalPaid: "Celkem zaplatíte",
      EmergencyFundAppreciation: "Zhodnocení rezervy",
      EmergencyFundCreation: "Tvorba rezervy",
      RecommendedEmergencyFundAmount: "Doporučená výše rezervy",
      WhatAreYouPlanning: "Co plánujete",
      Downpayment: "Vlastní zdroje",
      Overpayment: "Přeplacenost",
      InterestPaid: "Zaplaceno na úrocích",
      InvestCurrentSavings: "Zhodnotit stávající zdroje",
      RemainingPrincipal: "Zůstatek k doplacení",
      RecommendedEmergencyFundAmountHint: "Obecně je doporučeno mít finanční rezervu na pokrytí výpadku příjmů na min. 3 měsíce.",
      RetirementAge: "Věk odchodu do renty",
      RetirementDate: "Datum odchodu do renty",
      RetirementAgeDateHint: "Věk a datum se přepočítávají navzájem podle data narození klienta ({{birthDate}}).",
      RetirementDateMissingBirthDate: "Pro výpočet data doplňte datum narození klienta.",
      PlannedChild: "Plánované dítě",
      StatePensionSectionTitle: "Starobní důchod",
      StatePensionAmount: "Starobní důchod",
      StatePensionStart: "Starobní důchod od",
      StatePensionDerivedFromNetIncome: "Starobní důchod se dopočítá z čisté mzdy.",
      ScenarioPesimistic: "Pesimistický scénář",
      ScenarioRealistic: "Realistický scénář",
      ScenarioOptimistic: "Optimistický scénář",
      MonthlyPensionAmount: "Měsíční renta",
      PensionDuration: "Doba čerpání renty",
      ResetToDefaultValues: "Obnovit doporučené hodnoty",
      DetailsCanBeFoundOnSite: "Podrobnosti naleznete na webu",
      Cssz: "ČSSZ",
      TotalRequiredAmount: "Celková potřebná částka",
      TotalInvestedAmount: "Celkově investováno",
      EarlyAge: "raný věk",
      PrimarySchool: "základní škola",
      HighSchool: "střední škola",
      University: "vysoká škola",
      StartToLife: "start do života",
      MorgageComparisonTable: {
        Comparison: "Porovnání",
        Variant: "Varianta",
        LoanDuration: "Doba splácení",
        TotalLoanAmount: "Celkem zaplatíte",
        OneTimeAmount: "Jednorázově zaplatíte",
        Savings: "Úspora",
        OriginalRepayment: "Původní splacení",
        EarlyRepayment: "Předčasné",
      },
      PensionHint: {
        Title: "Zajištění životní úrovně",
        FirstPhrase: "Aby si klient zajistil stávající životní úroveň, musí do důchodu odcházet s naspořenou částkou minimálně",
        SecondPhrase: "Toho dosáhne při očekávaném zhodnocení",
        ThirdPhrase: "s měsíční investicí",
        ForDuration: "po dobu",
        RentPhrase: "Naspořená částka mu následně umožní čerpat rentu",
        Monthly: "měsíčně",
        FourthPhrase: "Ve fázi spoření je zahrnuta inflace",
        FifthPhrase: ", po jejímž odečtení je kalkulováno s reálným zhodnocením",
        SixthPhrase: "Do měsíční investice jsou zahrnuty poplatky ve výši",
        SeventhPhrase: "měsíčního vkladu",
        DrawdownFootnoteFirstPhrase: "Ve fázi čerpání je kalkulováno s reálným zhodnocením",
        DrawdownFootnoteSecondPhrase: ", které je již očištěné o inflaci. Inflace se proto v této fázi znovu neodečítá.",
      },
      PensionDifferenceHint: {
        Title: "Rozdílná výše renty",
        FirstPhrase: "V době čerpání renty před nárokem na starobní důchod, tj.",
        SecondPhrase: "je pro udržení životní úrovně uvažována renta ve výši",
      },
      QuiteOldHint: {
        Title: "Zajištění životní úrovně",
        FirstPhrase: "Klient dosáhl hranice",
        SecondPhrase: "věku. Je vhodné se zaměřit na aktuální limity a možnosti úvěru pro klienta u konkrétních hypotečních institucí.",
      },
      TooOldHint: {
        Title: "Zajištění životní úrovně",
        FirstPhrase: "Klient dosáhl hranice",
        SecondPhrase: "věku. Pro hypotečních instituce je klient rizikový z důvodu nedostatečné doby splácení úvěru.",
      },
      HasEnoughMoneyHint: {
        Title: "Dostatek prostředků",
        Content: "Klient má dostatek prostedků na pokrytí cíle. Zbylé prostředky je možné použít pro plnění ostatních cílů.",
      },
      OtherGoalHint: {
        Title: "Hodnota cíle",
        FirstPhrase: "Aby si klient zajistil pokrytí tohoto cíle, musí mít na počátku čerpání hodnotu",
        SecondPhrase: "Toho dosáhne při očekávaném zhodnocení",
        WithMonthlyInvestment: "s měsíční investicí",
        ForDuration: "po dobu",
      },
      GoalType: {
        Title: "Typ cíle",
        Pension: "Renta",
        FinancialReserveLong: "Finanční rezerva",
        FinancialReserve: "Fin. rezerva",
        Housing: "Bydlení",
        Vehicle: "Auto",
        Children: "Děti",
        Other: "Jiné",
      },
      GoalSubType: {
        HousingOther: "Jiné (fotovoltaika, rekonstrukce atd.)",
        HousingProperty: "Pořízení nemovitosti",
        HousingMortgage: "Splacení hypotéky",
      },
      Timeline: {
        SortOrder: "Řazení cílů",
        SortAsc: "Vzestupně",
        SortDesc: "Sestupně",
        EmptyStatePlaceholder: {
          Title: "Penze",
          Subtitle: "Renta v penzi je důležitý cíl v životě, nezapomeňte jej zahrnout do finančního plánu.",
        },
        ShortTermGoals: "Krátkodobé cíle",
        MidTermGoals: "Střednědobé cíle",
        LongTermPoint: "Dlouhodobé cíle",
        Today: "Dnes",
        Priority: "Prioritní",
        Completed: "Splněno",
        TypeWithTime: "{{type}} · {{time}}",
        Amount: "Částka",
        TargetAmount: "Cílová částka",
        LoanPaymentAmount: "Splátka úvěru",
        TargetSavingsAmount: "Částka k naspoření",
        PayoutAmount: "Čerpaná částka",
        PayoutFrequency: "Čerpání",
        PayoutFrom: "Čerpání od",
        PayoutTo: "Čerpání do",
        PayoutPoint: "{{age}} ({{date}})",
        Single: "Jednorázově",
        Regular: "Pravidelně",
        MonthlyRent: "Měsíční renta",
        MonthlyAmount: "{{amount}} / měs.",
        GoalType: {
          Pension: "Renta",
          FinancialReserve: "Finanční rezerva",
          Housing: "Bydlení",
          HousingProperty: "Bydlení – nemovitost",
          HousingMortgage: "Bydlení – hypotéka",
          HousingOther: "Bydlení – ostatní",
          Vehicle: "Auto",
          Children: "Děti",
          Other: "Ostatní",
        },
        RelativeTime: {
          ThisMonth: "tento měsíc",
          Future: "za {{duration}}",
          Past: "před {{duration}}",
          YearsAndMonths: "{{years}} a {{months}}",
          MonthsAgo_one: "{{count}} měsícem",
          MonthsAgo_few: "{{count}} měsíci",
          MonthsAgo_other: "{{count}} měsíci",
          YearsAgo_one: "{{count}} rokem",
          YearsAgo_few: "{{count}} lety",
          YearsAgo_other: "{{count}} lety",
        },
        Actions: {
          More: "Další akce",
          MarkCompleted: {
            Title: "Označit jako splněný",
            Description: "Cíl se přesune mezi splněné cíle.",
          },
          MarkNotCompleted: {
            Title: "Označit jako nesplněný",
            Description: "Cíl se vrátí mezi aktivní cíle.",
          },
          Archive: {
            Title: "Archivovat",
            Description: "Cíl se přesune mezi archivované cíle. Odtud ho lze kdykoli vrátit.",
          },
          Unarchive: {
            Title: "Vrátit mezi cíle",
            Description: "Cíl se vrátí do timeline.",
          },
          Edit: {
            Title: "Upravit cíl",
            Description: "Otevře formulář cíle.",
          },
          Delete: {
            Title: "Smazat cíl",
            Description: "Cíl se trvale odstraní, nelze vrátit.",
          },
          DeleteConfirm: {
            Title: "Smazat cíl",
            Text: "Opravdu chcete cíl „{{name}}“ smazat? Tuto akci nelze vrátit.",
          },
        },
        Archived: {
          Title: "Archivované cíle",
          Subtitle: "Zatím nejsou žádné cíle archivované.",
        },
      },
      ConfirmRecalculateTargetFromMonthly:
        "Změnili jste výši měsíční investice, což povede k jiné cílové částce v průběhu investičního horizontu. Přejete si upravit cílovou částku tak, aby odpovídala nastavené měsíční investici?",
    },
    Insurance: {
      LoadFromExistingExpenses: "Načíst stávající výdaje na pojištění",
      InfinityRent: "Nekonečná renta",
      RecommendedAmountLabels: {
        Default: "Výchozí doporučená částka",
        ForFirstMonth: "Pro 1. měsíc",
        ForSecondMonth: "Pro 2. měsíc",
        FromThirdMonth: "Pro 3. měsíc",
      },
      InsuranceRiskType: {
        DeathConstant: "Smrt - Konstantní",
        DeathDecreasingLinear: "Smrt - Lineárně klesající",
        DeathDecreasingAnnuity: "Smrt - Anuitně klesající",
        AccidentalDeath: "Smrt úrazem",
        Disability3rdDegreeConstant: "Invalidita 3. st. - Konstantní",
        Disability2ndDegreeConstant: "Invalidita 2. st. - Konstantní",
        Disability1stDegreeConstant: "Invalidita 1. st. - Konstantní",
        Disability3rdDegreeDecreasingLinear: "Invalidita 3. st. - Lineárně klesající",
        Disability2ndDegreeDecreasingLinear: "Invalidita 2. st. - Lineárně klesající",
        Disability1stDegreeDecreasingLinear: "Invalidita 1. st. - Lineárně klesající",
        Disability3rdDegreeDecreasingAnnuity: "Invalidita 3. st. - Anuitně klesající",
        Disability2ndDegreeDecreasingAnnuity: "Invalidita 2. st. - Anuitně klesající",
        Disability1stDegreeDecreasingAnnuity: "Invalidita 1. st. - Anuitně klesající",
        CriticalIllnessConstant: "Závažná onemocnění - Konstantní",
        CriticalIllnessDecreasingLinear: "Závažná onemocnění - Lineárně klesající",
        CriticalIllnessDecreasingAnnuity: "Závažná onemocnění - Anuitně klesající",
        PermanentInjuryFromLowestPercent: "Trvalé následky úrazu - Plnění od nejnižšího %",
        PermanentInjuryFrom10Percent: "Trvalé následky úrazu - Plnění od 10 %",
        WorkIncapacityFrom15thDay: "Pracovní neschopnost - Od 15. dne",
        WorkIncapacityFrom29thDay: "Pracovní neschopnost - Od 29. dne",
        WorkIncapacityFrom57thDay: "Pracovní neschopnost - Od 57. dne",
        WorkIncapacityFrom85thDay: "Pracovní neschopnost - Od 85. dne",
        NursingAllowanceFrom15thDay: "Ošetřovné - Od 15. dne (pouze u dítěte)",
        NursingAllowanceFrom29thDay: "Ošetřovné - Od 29. dne (pouze u dítěte)",
        NursingAllowanceFrom57thDay: "Ošetřovné - Od 57. dne (pouze u dítěte)",
        NursingAllowanceFrom85thDay: "Ošetřovné - Od 85. dne (pouze u dítěte)",
        InjuryTreatment: "Léčení úrazu",
        HospitalizationAccidentAndIllness: "Hospitalizace - Úraz i nemoc",
        HospitalizationAccident: "Hospitalizace - Úraz",
      },
      CoverageAmountType: {
        ClientIncomes: "Příjmy klienta",
        FamilyExpenses: "Výdaje rodiny",
        Other: "Jiné",
      },
      InsuranceContractCreated: "Nová smlouva vytvořena.",
      InsuranceContractEdited: "Smlouva úspěšně upravena.",
      InsuranceContractDeleted: "Smlouva úspěšně smazána.",
      AdditionalInformation: {
        Title: "Dodatečné informace",
        ChildrenCount: "Počet vyživovaných dětí",
        FamilyNetIncome: "Čistý příjem rodiny",
        NetIncomeInsured: "Čistý příjem pojištěného",
        FamilyExpenses: "Výdaje rodiny",
        InsureeExpenses: "Výdaje pojištěného",
        FamilyLiabilities: "Závazky rodiny",
        RemainingPrincipal: "Nesplacená částka",
        RepaymentDate: "Datum splatnosti",
        RemainingYears: "Doba splacení úvěru",
        ChildChip: "Dítě",
        IndividualChip: "Jednotlivec",
        BreadwinnerChip: "Primární/sekundární živitel rodiny",
        MainIncomeChip: "Hlavní příjem",
        IncomeTypes: {
          Employment: "Zaměstnání",
          Rental: "Pronájem",
          SelfEmployment: "OSVČ",
          Parental: "Rodičovský příspěvek",
          Pension: "Důchod",
          FirstDegreeDisability: "Invalidita 1. stupně",
          SecondDegreeDisability: "Invalidita 2. stupně",
          ThirdDegreeDisability: "Invalidita 3. stupně",
          Disability: "Invalidní důchod",
          OrphanPension: "Sirotčí důchod",
          WidowPension: "Vdovský důchod",
          OrphanOrWidowPension: "Sirotčí/vdovský důchod",
          Other: "Jiné",
        },
        ExpenseTypes: {
          Housing: "Bydlení",
          Consumption: "Spotřeba",
          LifeStyle: "Životní styl",
          Loan: "Úvěry",
          Insurance: "Pojištění",
          FinancialProduct: "Finanční produkty",
          Other: "Jiné",
        },
      },
      PercentageAmount: "Procentní výměra",
      AssesmentBase: "Výpočtový základ",
      BasicAmount: "Základní výměra",
      CalculateIndividually: "Spočítat klientovi individuálně",
      StateAidCalculation: "Výpočet státní podpory",
      StateAidCalculationInfo1: "Data pro výpočet lze nalézt na ePortálu ČSSZ v sekci ",
      StateAidCalculationInfo2:
        ". Klient se může přihlásit například přes bankovní identitu. Hodnoty jsou uvedeny v sekci Podrobnosti k výpočtu.",
      StateAidCalculationLink: "Informativní důchodová aplikace",
      Subtitle: "Osoba, pro kterou řešíte pojištění",
      GoToLifeUp: "Přejít do LifeUp",
      ExistingSolution: "Stávající řešení",
      RecommendedSolution: "Doporučené řešení",
      AddSolution: "Přidat řešení",
      AddMember: "Přidat člena",
      StateAid: "Státní podpora",
      RiskInsurance: "Pojištění rizik",
      DisabilityFirstLevel: "Invalidní důchod 1. stupně",
      DisabilitySecondLevel: "Invalidní důchod 2. stupně",
      DisabilityThirdLevel: "Invalidní důchod 3. stupně",
      WidowPension: "Vdovský/vdovecký důchod",
      OrphanPension: "Sirotčí důchod",
      Compensation: "Kompenzace",
      InsuranceAmountRequiredMinimum: "PČ - nutný základ",
      RequiredRiskCompensation: "Potřebná kompenzace rizika",
      InsuranceAmountTotalInfinitePension: "PČ - celková nekonečná renta",
      CalculateStateAidIndividually: "Spočítat státní podporu individuálně",
      RecalculateInsuranceAmounts: "Přepočítat pojistné částky a doporučit krytá rizika",
      InvestmentProductInterest: "Úrok investičního produktu",
      ShowCompensationParameters: "Zobrazit parametry kompenzace",
      HideCompensationParameters: "Skrýt parametry kompenzace",
      CoverageType: "Typ krytí",
      ClientSolution: "Řešení klienta",
      CoverageAmount: "Krytá částka",
      LiquidReserve: "Likvidní rezerva",
      ClientPrefersDefaultAmounts: "Klient preferuje doporučené pojistné částky",
      CurrentState: "Stávající stav",
      RecommendedState: "Doporučený stav",
      RequiredMinimum: "Nutný základ",
      StateAidEntryType: {
        Title: "Způsob zadání státní podpory",
        Individual: "Individuální státní podpora klienta",
        Average: "Průměrná státní podpora",
      },
    },
    Budget: {
      Subtitle: "Správa finančních příjmu a výdajů klienta",
      EntryType: "Způsob zadání",
      Aggregated: "Souhrnně",
      Individual: "Jednotlivě",
      Incomes: {
        Title: "Příjmy",
        Add: "Přidat příjem",
        AddMultiple: "Přidat příjmy",
        AddAnotherIncome: "Přidat další příjem",
        Edit: "Upravit příjem",
        MonthlyIncomes: "Měsíční příjmy",
        AggregatedIncomesAmount: "Celkový měsíční příjem",
        IncomeBelongsTo: "Příjem patří k",
        IncomeBelongsToCaption: "Příjem patří",
        IncomeType: "Typ příjmu",
        IncomeTypes: {
          Employment: "Zaměstnání",
          SelfEmployment: "OSVČ",
          Rental: "Pronájem",
          Parental: "Mateřská",
          ParentalFull: "Mateřská/rodičovská",
          Pension: "Starobní důchod",
          Disability: "Invalidní důchod",
          OrphanOrWidowPension: "Sirotčí / Vdovský",
          Other: "Jiné",
        },
        Form: {
          Fields: {
            IncomeName: "Název příjmu",
            IncomeAmount: "Příjem",
            PureIncome: "Čistý příjem",
            RealAverageIncome: "Skutečný průměrný příjem",
            AverageRentalIncome: "Průměrná výše nájmu",
            ParentalIncome: "Mateřská/rodičovská",
            PensionIncome: "Výše důchodu",
            DisabilityIncome: {
              FirstDegree: "Invalidní důchod 1. stupně",
              SecondDegree: "Invalidní důchod 2. stupně",
              ThirdDegree: "Invalidní důchod 3. stupně",
            },
            OrphanOrWidowIncome: {
              OrphanPension: "Sirotčí důchod",
              WidowPension: "Vdovský důchod",
            },
            DisabilityDegree: {
              Label: "Stupeň",
              First: "1. stupeň",
              Second: "2. stupeň",
              Third: "3. stupeň",
            },
            PensionKind: {
              Label: "Druh důchodu",
              Orphan: "Sirotčí",
              Widow: "Vdovský",
            },
          },
          Errors: {
            IncomeSubmitError: "Při zpracování požadavku nastala chyba",
            ClientNotInAnalysis: "Osoba už v analýze není, vyberte jinou.",
            IncomeNotFound: "Příjem mezitím někdo smazal, odeberte ho.",
            DataChanged: "Příjmy se mezitím změnily. Zkontrolujte je a uložte znovu.",
          },
          Buttons: {
            AddAnother: "Přidat další",
            RemoveItem: "Odebrat položku",
          },
        },
      },
      Expenses: {
        Title: "Výdaje",
        Hint: "Rozdělte výdaje na běžné výdaje a výdaje za finanční produkty. Běžné výdaje může klient upravit svým životním stylem, ale výdaje za finanční produkty můžete upravit přenastavením produktů a s touto částkou můžete dále počítat.",
        ExpenseType: "Typ výdaje",
        ExpenseTypes: {
          Housing: "Bydlení",
          Consumption: "Běžná spotřeba",
          LifeStyle: "Životní styl",
          Loan: "Úvěry",
          Insurance: "Pojištění",
          FinancialProduct: "Finanční produkt",
          Other: "Jiné",
          HousingExpenseTypes: {
            Rent: "Nájem",
            Electricity: "Elektřina",
            Gas: "Plyn",
            Water: "Voda",
          },
          ConsumptionExpenseTypes: {
            Food: "Jídlo",
            Drugstore: "Drogérie",
            Telecommunication: "Telefon + Internet",
            Cigarettes: "Cigarety",
            Vehicle: "Auto",
            Children: "Děti",
            Gifts: "Dárky",
          },
          LifeStyleExpenseTypes: {
            Vacation: "Dovolená",
            Hobbies: "Koníčky",
            Entertainment: "Zábava",
            Sport: "Sport",
            Health: "Zdraví",
          },
          LoanExpenseTypes: {
            Mortgage: "Hypotéky",
            BuildingSavings: "Úvěry ze StSp",
            Consumer: "Spotřebitelské úvěry",
            CreditCard: "Kreditní karty",
            Overdraft: "Kontokorenty",
          },
          InsuranceExpenseTypes: {
            LifeInsurance: "Životní programy",
            VehicleInsurance: "Povinné ručení",
            AccidentInsurance: "Havarijní pojištění",
            HouseInsurance: "Pojištění RD/bytu",
            Other: "Jiné",
          },
          FinancialProductExpenseTypes: {
            BuildingSaving: "Stavební spoření",
            PensionSaving: "Penzijní produkty",
            SavingAccount: "Spořící účet",
            Investment: "Investice",
            RealEstateFund: "Realitní fond",
            Commodities: "Komodity",
            Platform: "Platforma",
            Other: "Jiné",
          },
        },
        Form: {
          Buttons: {
            Add: "Přidat výdaj",
            Edit: "Upravit výdaj",
            AddCustomItem: "Přidat položku",
          },
          Placehodlers: {
            Name: "Název",
            OwnName: "Vlastní název",
          },
          Labels: {
            MonthlyInstallment: "Měsíční splátka",
            MonthlySaving: "Měsíční úložka",
            Item: "Název",
            Value: "Částka",
            Balance: "Zůstatek",
            Institution: "Instituce",
            BelongsTo: "Patří k",
            Frequency: "Frekvence",
          },
          Fields: {
            DetailedCheckbox: "Zadat podrobně",
            Aggregated: "Celkově",
            InsuranceExpensesAmount: "Výdaje na pojištění",
            FinancialProductExpensesAmount: "Výdaje na fin. produkty",
            LoanExpensesAmount: "Výdaje na úvěry",
            OtherExpensesAmount: "Ostatní výdaje",
          },
          Errors: {
            ExpenseSubmitError: "Při zpracování požadavku nastala chyba",
            ExpenseAmountZeroError: "Nelze uložit výdaj s celkovou částkou 0 Kč.",
          },
          DeleteExpenseItem: "Smazat položku",
          DeleteExpenseItemHint: "Opravdu chcete smazat položku?",
          DeleteLoanExpenseItemWithoutAssetHint: "Opravdu chcete smazat položku?",
          DeleteLoanExpenseItemWithAssetHint: "Přejete si smazat i závazek spojený s tímto výdajem?",
          DeleteLoanExpenseItemWithAssetSubmit: "Včetně závazku",
          DeleteLoanExpenseItemWithoutAssetSubmit: "Pouze výdaj",
          DeleteFinancialProductExpenseItemWithoutAssetHint: "Opravdu chcete smazat položku?",
          DeleteFinancialProductExpenseItemWithAssetHint: "Přejete si smazat i finanční majetek spojený s tímto výdajem?",
          DeleteFinancialProductExpenseItemWithAssetSubmit: "Včetně fin. majetku",
          DeleteFinancialProductExpenseItemWithoutAssetSubmit: "Pouze výdaj",
          DeleteExpense: "Smazat výdaj",
          DeleteExpenseHint: "Opravdu chcete smazat výdaj včetně všech položek?",
          DeleteFinancialProductExpenseWithAssetHint: "Přejete si smazat výdaj včetně finančního majetku spojeného s tímto výdajem?",
          DeleteLoanExpenseWithAssetHint: "Přejete si smazat výdaj včetně závazků spojených s tímto výdajem?",
        },
      },
      AllocatedGoalAmount: {
        Amount: "Částka",
        AmountTooltip:
          "Částka se počítá automaticky z volných prostředků. Pokud chcete na cíle použít jinou částku, zapněte možnost „Zadat částku manuálně“.",
        Form: {
          Fields: {
            IsAllocatedGoalAmountManuallySet: "Zadat částku manuálně",
          },
          Errors: {
            SubmitError: "Při zpracování požadavku nastala chyba",
          },
        },
      },
      Recap: {
        Title: "Rekapitulace",
        DetailedRecap: "Detailní rekapitulace",
        Difference: "Volné prostředky navíc",
        Incomes: "Přijmy souhrn",
        Expenses: "Výdaje souhrn",
        ExpensesInsurance: "Výdaje na pojištění",
        ExpensesFinancialProduct: "Výdaje na fin. produkty",
        ExpensesLoan: "Výdaje na úvěry",
        ExpensesOther: "Ostatní výdaje",
        NotInvestedReserve: "Rezerva, kterou nechci investovat",
        AllocatedGoalAmount: "Celkem na cíle",
        DifferenceTooltip: "Rozdíl mezi příjmy a výdaji. Částka, která klientovi měsíčně zbývá k dispozici.",
        AllocatedGoalAmountTooltip: "Částka určená na plnění cílů včetně výdajů na stávající finanční produkty.",
      },
    },
    GoalsFulfillment: {
      Title: "Plnění cílů",
      Subtitle: "Efektivní sledování a dosažení cílů klienta.",
      Error: {
        Title: "Nepodařilo se načíst data",
        Text: "Zkuste stránku načíst znovu. Pokud problémy přetrvávají, kontaktujte podporu.",
      },
      ShortTerm: "Krátkodobé cíle",
      MidTerm: "Střednědobé cíle",
      LongTerm: "Dlouhodobé cíle",
      short_term: "Krátkodobé cíle",
      mid_term: "Střednědobé cíle",
      long_term: "Dlouhodobé cíle",
      TargetAmount: "Cílová částka",
      FutureAmount: "Budoucí hodnota",
      ToContractingGrowUp: "Sjednat na GrowUp",
      Alerts: {
        NoLiaPermission: "Nemáte dostatečné oprávnění pro sjednávání smluv přes GrowUp.",
      },
      ContractValidation: {
        ErrorTitle: "Sjednání není možné",
        ErrorSubtitle: "Před pokračováním je nutné vyřešit následující chyby:",
      },
      Horizon: "Horizont",
      Current: "Stávající řešení",
      CurrentSolutionOverview: "Stávající řešení",
      CurrentSolutionEdit: "Upravit stávající řešení",
      NoSolution: "Zatím neexistuje žádné řešení",
      NoGoalsInHorizon: "Pokud chcete vytvořit řešení, musí být definované cíle v tomto horizontu.",
      NoGoalsInHorizonYet: "V tomto horizontu již nejsou definované žádné aktivní cíle.",
      AddSolution: "Přidat řešení",
      PortfolioGroupTitle: "Sjednatelné přes GrowUp",
      LoadCurrentSolution: "Načíst stávající smlouvy",
      Proposed: "Navrhovaná řešení",
      ProposedSolutionOverview: "Navrhovaná řešení",
      ProposedSolutionSteps: "Navrhované kroky řešení",
      ProposedSolutionEdit: "Upravit navrhované řešení",
      DeleteProposedSolutionTitle: "Smazat navrhované řešení",
      DeleteProposedSolutionText: "Opravdu chcete navrhované řešení smazat?",
      Characteristics: "Charakteristika nástroje",
      OneTimeFunds: "Jednorázové prostředky",
      RegularFunds: "Pravidelné prostředky",
      ProductNotAllowChange: "Vybraný produkt již nelze měnit.",
      InvestmentToolTypeOptions: {
        Title: "Typ nástroje",
        investment: "Investice",
        commodity: "Komodity",
        pension_saving: "Penzijní produkty",
        saving: "Spoření",
        other: "Jiné",
      },
      ProposedStepActionTypeOptions: {
        Title: "Způsob řešení",
        Keep: "Zachovat",
        Increase: "Úprava - navýšení vkladu",
        Decrease: "Úprava - snížení vkladu",
        Modify: "Upravit",
        Cancel: "Zrušit",
        Contracting: "Zasmluvnit",
      },
      CommoditiesSolutionOptions: {
        Title: "Způsob řešení",
        Keep: "Zachovat",
        Cancel: "Odkoupit",
        Increase: "Úprava - navýšení vkladu",
        Decrease: "Úprava - snížení vkladu",
        Modify: "Upravit",
        Contracting: "Zasmluvnit",
      },
      BrandOptions: {
        Title: "Značka",
        argo_heraeus: "Argo - Heraeus",
        pamp: "PAMP",
        munze_osterreich: "Münze Österreich",
      },
      IngotWeightOptions: {
        Title: "Váha slitků",
        weight_1g: "1 g",
        weight_2g: "2 g",
        weight_2g5: "2,5 g",
        weight_5g: "5 g",
        weight_10g: "10 g",
        weight_20g: "20 g",
        weight_31g1: "31,1 g",
        weight_50g: "50 g",
        weight_100g: "100 g",
        weight_250g: "250 g",
      },
      FundOptions: {
        Title: "Druh fondu",
        transformed_fund: "Transformovaný fond",
        dps: "DPS",
      },
      StrategyOptions: {
        Title: "Strategie",
        conservative: "Konzervativní",
        balanced: "Vyvážená",
        dynamic: "Dynamická",
      },
      FrequencyOptions: {
        Title: "Frekvence",
        OneTime: "Jednorázově",
        Monthly: "Měsíčně",
        Quarterly: "Čtvrtletně",
        HalfYearly: "Půlročně",
        Yearly: "Ročně",
      },
      SettingsMenu: {
        Title: "Nastavení zobrazení",
        PortfolioDistribution: "Rozložení investičního portfolia",
        FutureValueTitle: "Kalkulace budoucí hodnoty",
        CharacteristicsToggleDisabled: "Aby bylo možné aktivovat, musí být nejdříve vyplněny charakteristiky na všech smlouvách",
        SettingsEditFailed: "Uložení konfigurace selhalo.",
      },
      ContractingPartnersMenu: {
        Title: "Sjednat přes partnera",
        Atlantik: "Atlantik",
      },
      FormFields: {
        Institution: "Instituce",
        CurrentValue: "Aktuální zůstatek",
        InvestmentAmount: "Výše investice",
        RegularAmount: "Pravidelná úložka",
        Brand: "Značka",
        IngotWeight: "Váha slitků",
        IngotCount: "Počet slitků",
        Horizon: "Horizont",
        AppreciationRate: "Výkonnost",
        Fees: "Poplatky",
        EntryFee: "Vstupní poplatek [%]",
        EntryFeeShort: "Vstupní [%]",
        OneTimeFee: "Jednorázový poplatek [Kč]",
        OneTimeFeeShort: "Jednorázový [Kč]",
        ManagementFee: "Manažerský poplatek [%]",
        ManagementFeeShort: "Manažerský [%]",
        ExitFee: "Výstupní poplatek [%]",
        ExitFeeShort: "Výstupní [%]",
        Equities: "Akcie",
        Bonds: "Dluhopisy",
        Commodities: "Komodity",
        RealEstate: "Nemovitosti",
        Cash: "Hotovost",
        Other: "Ostatní",
        ProposedStepAction: "Způsob řešení",
        OneTimeDeposit: "Jednorázový vklad",
        NewDeposit: "Nový zůstatek",
        NewDepositDifference: "Změna zůstatku o částku",
        NewRegularDeposit: "Nová pravidelná úložka",
        NewRegularDepositDifference: "Změna pravidelné úložky o částku",
        ProposedSolutionHorizon: "Horizont",
        ProposedSolutionEntryFee: "Vstupní poplatek [%]",
        ProposedSolutionManagementFee: "Manažerský poplatek [%]",
        Partner: "Partner",
        Product: "Produkt",
        ClientId: "Patří k",
        EmployerDeposit: "Úložka zaměstnavatele",
        StateContribution: "Státní příspěvek",
        Note: "Poznámka",
        NotePlaceholder: "Moje poznámka...",
      },
      Sidebar: {
        CurrentSolution: "Stávající smlouvy",
        Bonds: "Dluhopisy",
        Equities: "Akcie",
        Commodities: "Komodity",
        RealEstate: "Nemovitosti",
        Cash: "Hotovost",
        Other: "Ostatní",
        ProposedSolution: "Navrhované smlouvy",
        CurrentBalance: "Aktuální zůstatek",
        CurrentRegularDeposit: "Současné pravidelné úložky",
        EndBalance: "Stav na konci",
        NewBalance: "Nový zůstatek",
        NewRegularDeposit: "Nové pravidelné úložky",
        NeededToSaveUp: "Požadovaný kapitál ke splnění cílů",
        PaymentStructure: "Struktura plateb",
        ShortTermInvestment: "Krátkodobá investice",
        MidTermInvestment: "Střednědobá investice",
        LongTermInvestment: "Dlouhodobá investice",
        OverallInvestment: "Celkem",
      },
      Nsure: {
        StrategyRiskType: {
          VeryConservative: "Velmi konzervativní",
          Conservative: "Konzervativní",
          Cautious: "Opatrné",
          Balanced: "Vyvážené",
          Growth: "Růstové",
          Dynamic: "Dynamické",
          VeryDynamic: "Velmi dynamické",
          Aggressive: "Agresivní",
        },
        InstrumentType: {
          Unknow: "Neznámý",
          Fund: "Fond",
          Stock: "Akcie",
          Bond: "Dluhopis",
          BankDeposits: "Bankovní vklady",
          ComplementaryPensionSaving: "Doplňkové penzijní spoření",
          RealEstate: "Nemovitosti",
          Share: "Podíl",
          BuildingSaving: "Stavební spoření",
          InvestmentLifeInsurance: "Investiční životní pojištění",
          OtherSpeculativeInvestment: "Jiná spekulativní investice",
          Strategy: "Strategie",
          PreciousMetals: "Drahé kovy",
          Crowdfunding: "Crowdfunding",
        },
        Labels: {
          Isin: "ISIN",
          Symbol: "Symbol",
          SrriSri: "SRRI / SRI",
          ExpectedPerformance: "Očekáv. zhodnocení",
          Esg: "ESG",
          Horizon: "Horizont",
          Name: "Název",
          Type: "Typ",
          Weight: "Váha",
        },
        PortfolioCard: {
          Category: "Kat:",
          Description: "Popis",
        },
        SelectionPanel: {
          SelectedPortfolio: "Vybrané portfolio",
          SelectedInstrument: "Vybraný nástroj",
        },
        SolutionSelect: {
          Title: "Výběr investičního nástroje",
          CustomSolution: "Vlastní řešení",
          CustomSolutionDescription: "Zvolte si nástroj podle svých preferencí.",
          CustomSolutionAction: "Zvolit vlastní řešení",
          ProposedStrategies: "Vybrat z navržených strategií",
          EvaluationTitle: "Vyhodnocení výběru",
        },
        InstrumentSearch: {
          SearchPlaceholder: "Vyhledat nástroj podle ISIN, názvu, ...",
          NoResultsTitle: "Žádné výsledky",
          NoResultsText: "Pro zadaný výraz nebyly nalezeny žádné nástroje.",
          SelectButton: "Vybrat",
          SearchEmptyTitle: "Vyhledejte nástroj",
          SearchEmptyText: "Zadejte výraz pro vyhledání nástroje (ISIN, název, symbol, ...)",
        },
        InstrumentDetail: {
          StrategyComposition: "Složení strategie",
          ExpandComposition: "Zobrazit složení strategie",
          CollapseComposition: "Skrýt složení strategie",
          InstrumentInfo: "Informace o nástroji",
        },
        Evaluation: {
          Title: "Vyhodnocení cílových trhů",
          InvestorType: "Typ Investora",
          CustomerCategory: "Kategorie zákazníka",
          RiskToleranceType: "Tolerance rizika",
          LossCapabilityType: "Schopnost nést ztráty",
          InvestmentPreferenceType: "Investiční preference",
          EsgType: "ESG",
          InvestmentHorizon: "Investiční horizont",
          WarningAlertTitle: "Nevyhovující cílové trhy",
          MissingQuestionnaireTitle: "Chybí investiční dotazník.",
          EvaluationFailedTitle: "Nepodařilo se získat vyhodnocení. Nástroj nelze sjednat.",
          WarningAlert:
            "Cílový trh investičního řešení neodpovídá informacím sděleným v investičním dotazníku. Investici není možné sjednat.",
          EvaluationNotFound: "Investiční dotazník není vyplněn. Pro sjednání je nutné jej vyplnit k vyhodnocení cílových trhů.",
          QuestionnaireNotSigned: "Investiční dotazník není podepsán klientem. Pro sjednání produktu je nutné jej podepsat.",
          QuestionnaireExpired: "Platnost investičního dotazníku vypršela. Pro sjednání je nutné jej vyplnit znovu.",
          RiskProfile: "Rizikový profil",
          RiskClientProfile: "Rizikový profil klienta",
          RiskInvestment: "Rizikovost investice",
          SuccessAlert: "Investici je možné sjednat.",
          SuccessTitle: "Investici je možné sjednat.",
          WarningTitle: "Investici není možné sjednat.",
          WarningTitleWithReason: "Investici není možné sjednat – nesplňuje {{criteria}}.",
          // the criteria in the accusative, as WarningTitleWithReason names them
          UnmetCriteria: {
            InvestorType: "typ investora",
            CustomerCategory: "kategorii zákazníka",
            RiskToleranceType: "toleranci rizika",
            LossCapabilityType: "schopnost nést ztráty",
            InvestmentPreferenceType: "investiční preference",
            ESGType: "ESG",
            InvestmentHorizon: "investiční horizont",
          },
          NotMet: "Nesplněno",
          TargetMarketsMet: "ze 7 cílových trhů splněno",
          SelectPortfolio: "Vyberte nástroj pro vyhodnocení cílových trhů.",
          EvaluateError: "Chyba při vyhodnocení cílových trhů. Zkuste to prosím znovu.",
        },
        Details: {
          Title: "Položky investičního nástroje",
          BackToSelection: "Zpět na výběr",
          FeesInfoAlert: "Výše poplatků slouží pouze pro výpočet v Analyzátoru. Skutečné poplatky nastavíte v GrowUp před sjednáním.",
          LoadError: "Chyba při načítání navrhovaného řešení.",
        },
        ReadOnly: {
          Basics: "Základní údaje",
          Title: "Detail navrhovaného řešení",
          InfoAlert:
            "Pro tento horizont už neexistuje investiční plán, proto lze zobrazit pouze základní detail nástroje bez možnosti úprav. Nástroj nelze sjednat.",
        },
        Justification: {
          Title: "Prohlášení o vhodnosti",
          TitleDescription:
            "Popište vlastními slovy, proč doporučení odpovídá právě tomuto klientovi. Vycházejte z jeho odpovědí v investičním dotazníku a individuálních potřeb a požadavků. ",
          ContinueToGrowUp: "Pokračovat ke sjednání",
          SuitabilityInvestmentPlan: "Vyhovuje investiční doporučení preferencím v oblasti Investiční cíle klienta?",
          SuitabilityKnowledgeAndExperience: "Vyhovuje investiční doporučení preferencím v oblasti Znalosti a zkušenosti klienta?",
          SuitabilityInvestmentHorizon: "Vyhovuje investiční doporučení preferencím v oblasti Investiční horizont klienta?",
          SuitabilityFinanceSituation: "Vyhovuje investiční doporučení preferencím v oblasti Finanční situace klienta?",
          SuitabilityRiskTolerance: "Vyhovuje investiční doporučení preferencím v oblasti Tolerance k riziku klienta?",
          SuitabilityESG: "Vyhovuje investiční doporučení preferencím v oblasti ESG preference?",
          SuitabilityAdditionalStatement: "Doplňující vyjádření poradce k poskytnutému investičnímu poradenství",
          SuitabilityDate: "Předáno klientovi",
          SuitabilityInvestmentPlanPlaceholder: "Uveďte, jak investiční doporučení pomáhá naplnit investiční cíle klienta.",
          SuitabilityKnowledgeAndExperiencePlaceholder: "Popište, proč je doporučení vhodné vzhledem ke znalostem a zkušenostem klienta.",
          SuitabilityInvestmentHorizonPlaceholder: "Jak odpovídá investiční horizont doporučení požadavkům klienta?",
          SuitabilityFinanceSituationPlaceholder: "Popište, jak doporučení vyhovuje finanční situaci klienta.",
          SuitabilityRiskTolerancePlaceholder: "Uveďte, proč je doporučení vhodné vzhledem ke klientově toleranci k riziku.",
          SuitabilityESGPlaceholder: "Jak naplňuje doporučení ESG preference klienta?",
          SuitabilityAdditionalStatementPlaceholder: "Uveďte potřebné doplňující informace.",
          IsClientAgreed: "Zákazník s doporučením souhlasí a požaduje uvedený nákup a prodej",
          IsClientAgreedOptionA: "Zákazník souhlasí s doporučením a požaduje uvedený nákup a prodej",
          IsClientAgreedOptionB: "Zákazník nesouhlasí s doporučením",
          AgentStatement: "Vyjádření poradce",
          AgentStatementPlaceholder: "Popište vyjádření poradce k odmítnutí doporučení.",
          StatementDate: "Předáno klientovi",
          EndNegotiation: "Ukončit sjednávání",
        },
        InvestmentCaseStatus: {
          Alert: "Vybrané řešení sjednatelné přes GrowUp již nelze měnit. Stav investičního případu: {{status}}",
        },
      },
    },
    Modeling: {
      AvailableResources: "Volné prostředky",
      AvailableMonthlyResources: "Volné měsíční prostředky",
      ResourcesToInvest: "Prostředky k zainvestování",
      Recurring: "Pravidelné",
      RecurringReset: "Pravidelné prostředky úspěšně resetovány.",
      OneTimeReset: "Jednorázové prostředky úspěšně resetovány.",
      FinancialAssets: "Finanční majetek",
      ResourcesToInvestEdited: "Editace prostředků k zainvestování proběhla úspěšně.",
      AssetsAssigned: "Majetek úspěšně přiřazen.",
      AssetsEdited: "Editace majetku proběhla úspěšně.",
      AssetsDeleted: "Smazání majetku proběhlo úspěšně.",
      AssetsReallocated: "Přerozdělení proběhlo úspěšně.",
      RemainingForRedistribution: "Zbývá k rozdělení",
      ExistingFinancialProducts: "Existující finanční produkty",
      MissingAmount: "K naplnění cílové částky zbývá",
      CurrentCoverage: "Aktuálně pokryto z cílové částky",
      FromTotal: "Z celkových",
      Redistribute: "Přerozdělit",
      AssetAndPersonalInsuranceCoverage: "Pokrytí zajištění osob a majetku",
      ExistingInsuranceExpenses: "Stávající výdaje na pojištění",
      IncreasedInsuranceExpenses: "Navýšené výdaje na pojištění",
      IncreasedInsuranceExpensesUpdated: "Editace výdajů na pojištění proběhla úspěšně.",
      IncreasedInsuranceExpensesError: "Chyba při ukládání výdajů na pojištění.",
      GoalCoverage: "Pokrytí cílů",
      Needed: "Potřeba k dosažení cíle",
      Covered: "Aktuálně přiřazeno",
      Reset: "Resetovat",
      TimeHorizon: "Horizont",
      SelectCoverage: "Vybrat pokrytí",
      NoAssetsToDistribute: "Žádný finanční majetek k rozdělení.",
      ChangesMade: "Došlo ke změně!",
      Overdistribution: "Je dostupných méně prostředků, než kterými pokrýváte cíle. Snižte položky, které jsou nad rozpočet.",
      Monthly: "Měsíčně",
      OneTime: "Jednorázově",
    },
  },
  NewAnalysis: {
    Title: "Nová analýza",
    Address: "Adresa",
    Form: {
      Field: {
        FirstName: "Jméno",
        LastName: "Příjmení",
        AcademicDegreePrefix: "Titul před",
        AcademicDegreePostfix: "Titul za",
        BirthDate: "Datum narození",
        Street: "Ulice",
        HouseNumber: "Č.p.",
        StreetNumber: "Č.o.",
        City: "Město",
        PostalCode: "PSČ",
        Country: "Země",
        PersonalIdentificationNumber: "Rodné číslo",
        CreateMangoClient: "Založit současně i zájemce v MangoUp",
      },
      Button: {
        Continue: "Pokračovat v této analýze",
      },
    },
    BirthNumberLookup: {
      NotAccessible:
        "Klient s tímto rodným číslem už v MangoUp existuje, ale nemáte k němu přístup. Analýzu můžete vytvořit jen s lokálním klientem – vypněte založení zájemce v MangoUp.",
    },
    FoundClientDialog: {
      Title: "Klient už v MangoUp existuje",
      Text: "S tímto rodným číslem je v MangoUp veden klient {{client}}. Pokračujte s ním, nebo rodné číslo smažte.",
      Continue: "Pokračovat s klientem",
      ClearBirthNumber: "Smazat rodné číslo",
    },
    ExistingAnalysis: {
      Created: "Vytvořeno: {{date}}",
      Version: "V.{{version}}",
      Creator: "Vytvořil:",
    },
    Tab: {
      MyAnalyses: "Moje analýzy",
      OtherAnalyses: "Ostatní analýzy",
    },
    NoAnalyses: {
      Title: "Tento klient zatím nemá žádnou analýzu",
      Subtitle: "Vytvořte jeho finanční plán",
    },
    NoOtherAnalyses: {
      Title: "Tento klient nemá žádnou analýzu od jiného poradce",
    },
    Toast: {
      ClientAlreadyExists: "Klient s těmito údaji již existuje.",
      CreateClientError: "Klienta se nepodařilo vytvořit.",
      InvalidBirthNumber: "Rodné číslo je neplatné.",
      BirthNumberLookupError:
        "Rodné číslo se nepodařilo ověřit v MangoUp. Zadejte ho znovu, nebo vypněte založení zájemce a vytvořte analýzu s lokálním klientem.",
      UnsupportedAddressCountry: "Klienta s adresou ve vybrané zemi nelze v MangoUp založit.",
      CreateAnalysisError: "Analýzu se nepodařilo vytvořit.",
      NsureSelfDealingForbidden: "Nelze založit analýzu pro klienta, který má shodu v kontraktačních údajích s údaji poradce.",
    },
  },
  Questionnaire: {
    Title: "Investiční dotazník",
    Subtitle: "Pro správné nastavení řešení naplnění cílů klienta je potřeba vyplnit s klientem investiční dotazník.",
    InvestmentGoalsTitle: "Investiční cíle",
    InvestmentGoalsSubtitle: "Na co chce klient naspořit",
    Evaluate: "Vyhodnotit",
    Validation: {
      SelectOne: "Vyberte jednu z možností",
      MissingAnswersOne: "Chybí {{count}} odpověď.",
      MissingAnswersFew: "Chybí {{count}} odpovědi.",
      MissingAnswersOther: "Chybí {{count}} odpovědí.",
    },
    GoalCard: {
      Horizon: "Horizont",
      TargetAmount: "Cílová částka",
    },
    MoreActions: {
      Title: "Další akce",
      ShowPdf: "Zobrazit dotazník v PDF",
      SendEmail: "Odeslat dotazník na email",
    },
    ChangeReasonModal: {
      Title: "Odůvodnění změny v dotazníku",
      Subtitle: "Uveďte důvod, proč dochází k novému vyhodnocení investičního dotazníku před uplynutím doby platnosti.",
      Reason: "Důvod",
    },
    NoGoals: {
      Title: "Investiční dotazník není možné vyplnit",
      Text: "Pro vyplnění dotazníku je nutné definovat alespoň jeden cíl.",
    },
    ReadOnly: {
      Title: "Investiční dotazník nelze vyplnit.",
      Text: "Analýza je ve stavu, který neumožňuje vyplnit investiční dotazník.",
    },
    Error: {
      Title: "Při inicializaci investičního dotazníku vznikly chyby",
      Text: "Zkuste stránku načíst znovu. Pokud problémy přetrvávají, kontaktujte: {{email}}.",
    },
    QuestionsModified: {
      Title: "Dotazník je nutné zkontrolovat",
      TextGoalsChanged:
        "Od posledního vyhodnocení byly upraveny otázky dotazníku (změna cílů). Pro správné vyhodnocení je nutné dotazník znovu vyplnit.",
      TextNsureChanged:
        "Od posledního vyhodnocení byly upraveny otázky dotazníku (výchozí sada otázek). Pro správné vyhodnocení je nutné dotazník znovu vyplnit.",
      Action: "Zkontrolovat dotazník",
    },
    Expired: {
      Title: "Platnost dotazníku vypršela",
      Text: "Pro sjednání je nutné mít dotazník aktualizovaný.",
      Action: "Vyplnit dotazník znovu",
    },
    InvestmentCaseStatus: {
      Title: "Stav investičního případu",
      Text: "Aktuální stav investičního případu již neumožňuje provádět změny.",
      StatusTitles: {
        InSignature: "GrowUp: Investiční smlouvy čekají na podpis. Platnost návrhu smluv je 14 dní od vytvoření.",
        Signed: "GrowUp: Investiční smlouvy jsou podepsané.",
        Done: "GrowUp: Investiční smlouvy jsou úspěšně dokončené.",
        Rejected: "GrowUp: Investiční případ byl odmítnut",
        Cancelled: "GrowUp: Investiční případ byl zrušen",
        Error: "GrowUp: Během sjednávání vznikly chyby",
      },
    },
    Horizon: {
      short: "Krátkodobé cíle",
      middle: "Střednědobé cíle",
      long: "Dlouhodobé cíle",
      past: "-",
    },
    Sidebar: {
      RiskTolerance: {
        Title: "Riziková tolerance",
        Description: "Zjišťuje, jak velké výkyvy hodnoty investice je klient ochotný akceptovat, aniž by měnil strategii.",
      },
      LossCapability: {
        Title: "Schopnost nést ztrátu",
        Description: "Hodnotí, zda by klient zvládl pokles hodnoty investice bez dopadu na životní úroveň a plnění ostatních závazků.",
      },
      InvestmentPreference: {
        Title: "Investiční preference",
        Description: "Zjišťuje konkrétní preference klienta ohledně typů aktiv, geografického zaměření a způsobu zhodnocení.",
      },
      FinancialBackground: {
        Title: "Finanční zázemí",
        Description:
          "Zjišťuje celkovou finanční stabilitu klienta. Díky tomu je možné sestavit navrhované řešení, které bude dlouhodobě udržitelné a bude sloužit k naplnění cílů klienta.",
      },
      KnowledgeTest: {
        Title: "Test znalostí",
        Description:
          "Dotazník na znalosti klienta v oblasti kapitálových trhů. Účelem testu znalostí a zkušeností je posoudit, jaké investice jsou s ohledem na odborné znalosti a zkušenosti v oblasti investování pro zákazníka přiměřené pro pochopení souvisejících rizik. Jedná se o získání informací dle § 15i zákona o podnikání na kapitálovém trhu.",
      },
      ExperienceTest: {
        Title: "Test zkušeností",
        Description: "Dotazník na zkušenosti klienta v oblasti kapitálových trhů.",
      },
      EsgPreferences: {
        Title: "ESG preference",
        Description: "Zjišťuje, zda klient preferuje udržitelné investice (environmentální, sociální, správa věcí veřejných).",
      },
    },
    Evaluation: {
      Title: "Vyhodnocení",
      Subtitle: "Vyhodnocení vhodnosti a cílových trhů",
      InvestorType: "Typ investora",
      GoalsTitle: "Vyhodnocení cílů",
      GoalsSubtitle: "Vyhodnocení cílových trhů jednotlivých cílů",
      RiskProfile: "Rizikový profil",
      FinancialSituation: "Finanční situace klienta",
      LossCapability: "Schopnost nést ztrátu",
      InvestmentPreference: "Investiční preference",
      EsgEU: "Preference udržitelnosti dle taxonomie EU",
      EsgConseq: "Zohlednění faktorů nepříznivých dopadů",
      RiskTolerance: "Tolerance k riziku",
      SustainableInvestmentPreference: "Preference udržitelných investic",
      TitleVerification: "Podpis klienta",
      ShowQuestionnaire: "Náhled investičního dotazníku",
      ShowEvaluation: "Zobrazit vyhodnocení",
      ChangeAnswers: "Změnit odpovědi",
      Knowledge: "Znalosti",
      Experience: "Zkušenosti",
      Status: {
        Title: "Stav dotazníku",
        LastUpdatedAt: "Poslední vyhodnocení",
        ValidUntil: "Platnost do",
        RemainingOne: "zbývá {{duration}}",
        RemainingFew: "zbývají {{duration}}",
        RemainingOther: "zbývá {{duration}}",
        Signed: "Podpis klienta",
        NotSigned: "Nepodepsáno",
      },
      SendPdf: {
        Title: "Dokumenty",
        Format: "PDF",
        Evaluated: "Vyplněný dotazník s vyhodnocením",
        Filled: "Vyplněný dotazník",
        Preview: "Zobrazit",
        Send: "Odeslat na e-mail",
        Sent: "PDF dotazníku bylo odesláno na email klienta",
        EmailInvalid: "Email není možné odeslat. Zkontrolujte prosím emailovou adresu klienta.",
        BirthDateMissing: "Email není možné odeslat. Klient nemá vyplněné datum narození.",
        Confirm: {
          Title: "Odeslat PDF",
          EmptyText: "Opravdu chcete odeslat nevyplněný investiční dotazník klientovi na email: {{email}} ?",
          EvaluatedText: "Opravdu chcete odeslat vyplněný investiční dotazník s vyhodnocením klientovi na email: {{email}} ?",
        },
      },
      InvestorTypeOptions: {
        None: "Bez znalostí",
        Basic: "Základní",
        Informed: "Informovaný",
        Advanced: "Pokročilý",
      },
      RiskProfileTypeOptions: {
        Level_1: "Konzervativní",
        Level_7: "Dynamický",
      },
      RiskToleranceTypeOptions: {
        Level_1: "Nízká",
        Level_7: "Vysoká",
      },
      FinancialSituationTypeOptions: {
        Level_1: "Nestabilní",
        Level_7: "Silná",
      },
      LossCapabilityTypeOptions: {
        No: "Klient není schopen nést ztrátu",
        Yes: "Klient je schopen nést ztrátu",
      },
      InvestmentPreferenceTypeOptions: {
        WithoutLoss: "Garance beze ztrát",
        Protection: "Ochrana",
        Grow: "Růst",
        ProtectionOrGrowth: "Ochrana nebo růst",
        Growth: "Růst",
      },
      EsgTypeOptions: {
        Percent_0: "Není preferováno",
        Percent_1_24: "Do 25 %",
        Percent_25_49: "Alespoň 25 %",
        Percent_50_100: "Alespoň 50 %",
        Percent_100: "100 %",
        NotDefined: "Není definováno",
        Yes: "Ano",
        No: "Nezohledňuje udržitelnost (ESG 6)",
        YesAdditionally: "Částečně zohledňuje udržitelnost - LIGHT GREEN (ESG 8)",
        YesMainly: "Plně zohledňuje udržitelnost - DARK GREEN (ESG 9).",
      },
      EsgEUTypeOptions: {
        No: "Ne",
        Yes: "Ano",
      },
      EsgConsequenceTypeOptions: {
        No: "Ne",
        Yes: "Ano",
      },
    },
    OrganizedBy: "Schůzku vyvolal",
    OrganizedByWho: "Kdo",
    OrganizedByOptions: {
      Client: "Zákazník",
      Agent: "Poradce",
    },
  },
  PdfTemplate: {
    Header: {
      Title: "Finanční analýza",
      Questionnaire: "Investiční dotazník",
    },
  },
  Clients: {
    Title: "Klienti",
    SearchPlaceholder: "Vyhledejte klienta podle příjmení, telefonu nebo emailu...",
    SearchError: "Při vyhledávání došlo k chybě",
    SearchPlaceholderShort: "Vyhledat klienta",
    ClearSearch: "Vymazat hledání",
    ConnectClientToMango: "Spárovat s klientem z MangoUp",
    UpdateInMango: "Upravit v MangoUp",
    AssignClient: "Přiřadit klienta",
    MangoLinkedTitle: "Přiřazeno ke klientovi z MangoUp",
    MangoNotLinkedTitle: "Klient není přiřazený v MangoUp",
    MangoNotLinkedText: "Pro korektní práci analyzátoru je nutné přiřadit klienta z MangoUp.",
    MangoCardNeedCheck: "Kartu klienta je nutné zkontrolovat a doplnit chybějící položky.",
    MangoCardMissing:
      "Klient zatím nemá Kartu klienta. Kartu je nutné v MangoUp založit, zvalidovat a podepsat. Do nSure se klient propíše až po jejím podpisu.",
    EditSuccess: "Editace klienta proběhla úspěšně.",
    EditError: "Při editaci došlo k chybě.",
    AssignSuccess: "Klient byl úspěšně přiřazen.",
    AssignError: "Při přiřazení klienta došlo k chybě.",
    AssignErrors: {
      ClientNotLocal: "Klienta nelze přiřadit.",
      ClientNotAllowed: "Přiřazení klienta není povoleno.",
      AnalysisAlreadyExists: "Pro tohoto klienta již existuje jiná analýza.",
      NsureSelfDealingForbidden: "Nelze přiřadit klienta, který má shodu v kontraktačních údajích s údaji poradce.",
    },
    AssignConfirmTitle: "Přiřadit klienta",
    AssignConfirmTextPrefix: "Opravdu chcete přiřadit klienta:",
    AssignConfirmTextSuffix: "k analýze? Tato akce změní vazbu klienta na analýzu a nelze změnit.",
    LoadError: "Nepodařilo se načíst data klienta.",
    IncompleteMangoClient: {
      Title: "Profil klienta {{client}} v MangoUp je neúplný",
      Text: "Pro správné fungování analyzátoru je nutné doplnit chybějící údaje klienta v MangoUp.",
    },
    ClientCard: {
      Title: "Karta klienta",
      MissingHint: "Kartu klienta je nutné v MangoUp založit, zvalidovat a podepsat.",
      Minor: "Nezletilý",
      LegalRepresentative: {
        Title: "Zákonný zástupce",
        ShowDetails: "Zobrazit údaje",
        HideDetails: "Skrýt údaje",
      },
      Status: {
        NotInMangoUp: "Nepřiřazen v MangoUp",
        Missing: "Nezaložena",
        Actual: "Aktuální",
        Outdated: "Neaktuální",
        Unsigned: "Nepodepsáno",
      },
      Alerts: {
        NotInMangoUp: "Klient není přiřazen v systému MangoUp. Pro sjednání produktu je nutné klienta nejprve přiřadit.",
        Missing:
          "Klient zatím nemá Kartu klienta v MangoUp. Pro sjednání produktu je nutné kartu v MangoUp založit, zvalidovat a podepsat. Do nSure se klient propíše až po jejím podpisu.",
        Unsigned:
          "Klient nemá podepsanou Kartu klienta v MangoUp. Pro sjednání produktu je nutné formuláře podepsat. Do nSure se klient propíše až po podpisu karty.",
        Outdated: "Klient nemá aktuální Kartu klienta v MangoUp. Pro sjednání produktu je nutné dokumentaci aktualizovat.",
        NotAvailable: "Klient není dostupný.",
        AdultWithLegalRepresentative: {
          Title: "Klient je již plnoletý, ale stále má zákonného zástupce.",
          Text: "Pokud zastoupení skončilo, odeberte zákonného zástupce v MangoUp.",
        },
      },
    },
    Field: {
      FirstName: "Jméno",
      LastName: "Příjmení",
      AcademicDegreePrefix: "Titul před",
      AcademicDegreePostfix: "Titul za",
      BirthDate: "Datum narození",
      Email: "E-mail",
      Street: "Ulice",
      StreetNumber: "Č.o.",
      HouseNumber: "Č.p.",
      City: "Město",
      PostalCode: "PSČ",
      Country: "Země",
      PersonalIdentificationNumber: "Rodné číslo",
    },
    ClientError: "Nepodařilo se načíst klienta.",
    Empty: {
      Title: "Žádné výsledky",
      Text: "Vyhledávání neodpovídají žádné výsledky. Ujistěte se, že hledaný výraz odpovídá údajům hledaného klienta.",
    },
    ExistingClientsGroup: "Klienti MangoUp",
    LocalClientsGroup: "Klienti lokální",
    MangoUpChipLabel: "MangoUp",
    Detail: {
      SendSMSCode: "Odeslat SMS kód",
      Signed: "Podepsáno",
      SMSVerifyModal: {
        Subtitle: "Zadejte SMS kód, který byl zaslán klientovi na uvedené číslo.",
        CodeSent: "SMS kód odeslán",
        ResendCode: "Odeslat kód znovu",
        VerificationSuccess: "Verifikace úspěšná",
        InvalidCode: "Zadaný SMS kód je neplatný. Zkuste to prosím znovu.",
      },
    },
  },
  ReportIssue: {
    Title: "FAQ",
    SubTitle: "Najděte odpovědi na nejčastější otázky k používání Analyzátoru.",
    Feedback: {
      Prompt: "Máte nápad na vylepšení nebo zpětnou vazbu?",
      SendEmailTo: "Napište nám na e-mail",
      NotForIssues: "Problémy s analýzou prosím hlaste přímo z detailu analýzy přes ikonu Nahlásit problém.",
    },
    FAQ: {
      Sections: {
        General: {
          Title: "Obecné otázky",
          Item1: {
            Question: "Jak nahlásit problém v analýze?",
            Answer:
              "Problém nahlaste přímo z analýzy, ve které nastal. V detailu analýzy klikněte v záhlaví vedle ikony interní poznámky na ikonu **Nahlásit problém**, popište, co se stalo, a přiložte až 3 obrázky nebo videa.\n\nÚdaje o analýze, poradci a prohlížeči se k hlášení připojí automaticky, nemusíte je tedy vypisovat.",
          },
        },
        ClientAndFamily: {
          Title: "Klient a rodina",
          Item1: {
            Question: "Mohu při vytváření analýzy rovnou propojit klienta s MangoUP?",
            Answer: "Ano. Klienta z MangoUP můžete propojit přímo při vytváření analýzy.",
          },
          Item2: {
            Question: "Jak funguje vyhledávání klientů?",
            Answer:
              "Vyhledávání funguje na základě kontaktní osoby a viditelněných klientů. Pokud tomu tak není, zkontrolujte kartu klienta (KK) v MangoUP a viditelnost na klienta. V případě nesrovnalostí nás kontaktujte na e-mailu uvedeném níže.",
          },
          Item3: {
            Question: "Adresa zobrazená v Analyzátoru není správná.",
            Answer: "Zkontrolujte adresu klienta v MangoUP. Analyzátor zobrazuje adresu v reálném čase podle údajů evidovaných v MangoUP.",
          },
          Item4: {
            Question: "Omylem jsem propojil analýzu s nesprávným klientem z MangoUP. Co mám dělat?",
            Answer:
              "Vytvořte novou analýzu a propojte ji se správným klientem z MangoUP. Chybně propojenou analýzu můžete využít pro klienta, kterého jste omylem přiřadili.",
          },
          Item5: {
            Question: "Mohu vytvořit analýzu bez propojení s klientem v MangoUP?",
            Answer:
              "Ano. Pokud vytvoříte analýzu bez propojení s klientem z MangoUP, bude vedena jako **lokální analýza**. V takové analýze můžete provádět výpočty i modelace bez omezení. Pokud se následně rozhodnete sjednávat produkty, stačí u jedné konkrétní analýzy propojit klienta z MangoUP, vyplnit investiční dotazník a poté můžete pokračovat ve sjednávání.",
          },
          Item6: {
            Question: "Jaký význam má datum narození v analýze?",
            Answer:
              "Datum narození vstupuje do řady výpočtů finančních cílů, především při určování investičního horizontu nebo délky spoření. Například u cíle **Renta** je výpočet přímo závislý na datu narození klienta.",
          },
          Item7: {
            Question: "Změnila se mi data v analýze (například výše měsíční úložky).",
            Answer:
              "Pokud je analýza ve stavu **Rozpracováno**, její data nejsou uzamčena. To znamená, že pokud analýzu otevřete například za několik měsíců, mohou být některé výpočty odlišné od původních, protože vycházejí z aktuálních údajů. Pokud je analýza dokončená a produkty byly sjednány, doporučujeme ji přepnout do stavu **Dokončeno**. Tím se výpočty uzamknou a již se nebudou měnit.",
          },
        },
        GoalsAndQuestionnaire: {
          Title: "Cíle a investiční dotazník",
          Item1: {
            Question: "Mám vytvořený cíl, ale nevidím ho v přehledu Plnění cílů.",
            Answer:
              "Zkuste upravit některý z parametrů cíle, například cílovou částku nebo investiční horizont. Pokud se cíl po úpravě zobrazí, pravděpodobně se jednalo o starší (legacy) záznam, který bylo potřeba aktualizovat.",
          },
          Item2: {
            Question: "Investiční dotazník hlásí, že nemám žádný cíl, přestože jsem ho vytvořil.",
            Answer:
              "Pro investiční dotazník se započítávají pouze **aktivní cíle**. Pokud je cíl archivovaný nebo označený jako splněný, nebude se do dotazníku počítat. Vytvořte nový aktivní cíl nebo obnovte některý ze stávajících.",
          },
          Item3: {
            Question: "Vyplnil jsem investiční dotazník, ale potřebuji opravit chybu.",
            Answer: "Pokud je investiční dotazník v neplatném stavu, použijte tlačítko pro opětovné vyplnění dotazníku.",
          },
          Item4: {
            Question: "Nedaří se mi podepsat investiční dotazník pomocí SMS.",
            Answer:
              "Pokud klientovi nepřišla SMS s ověřovacím kódem, ověřte nejprve, že nemá blokované nebo filtrované SMS zprávy. Nový ověřovací kód lze odeslat nejdříve po **30 vteřinách**, aby nedocházelo ke spamování. Pokud mezitím dorazí původní SMS s kódem, je stále možné ji použít pro dokončení podpisu.",
          },
          Item5: {
            Question: "Proč nemám podepsaný investiční dotazník, když jsem ho nedávno podepsal?",
            Answer:
              "Pokud se po vyplnění dotazníku změnila cílová částka nebo investiční horizont některého z cílů, změní se i otázky dotazníku a dotazník přejde do stavu **Dotazník je nutné zkontrolovat**. V takovém případě použijte tlačítko **Zkontrolovat dotazník**. Dotazník je předvyplněný, stačí jej doplnit.",
          },
        },
        Contracting: {
          Title: "Sjednávání",
          Item1: {
            Question: "Co je nutné vyplnit pro sjednávání přes GrowUP?",
            Answer:
              "Pro sjednání investičního produktu prostřednictvím GrowUP je potřeba splnit následující podmínky:\n• klient je propojen s MangoUP,\n• existuje alespoň jeden **aktivní cíl** (není archivovaný ani označený jako splněný),\n• je vyplněný a podepsaný investiční dotazník.\n\nVyplnění příjmů, výdajů, stávajících produktů nebo vytvoření modelace není pro samotné sjednání povinné. Tyto kroky však doporučujeme pro zpracování kompletní finanční analýzy klienta.",
          },
          Item2: {
            Question: "Jak sjednám vlastní investiční řešení?",
            Answer: "Při přidávání investice klikněte na ikonu **tužky** a zvolte možnost **Zvolit vlastní řešení**.",
            ImageAlt: "Ukázka volby vlastního investičního řešení",
          },
          Item3: {
            Question: "Jak fungují oblíbená portfolia?",
            Answer:
              "Oblíbená portfolia v analyzátoru se skládají obvykle více než jednoho investičního nástroje. Při výběru jednoho portfolia vidíte jeho složení a % rozložení. Dle tohoto % rozložení se rozkládají i jednorázové a pravidelné vklady. Pro úpravu oblíbeného portfolia je potřeba upravit každou smlouvu zvlášť. ZFP Gold **nelze** sjednat přes Growup.",
            ImageAlt: "Ukázka složení oblíbeného portfolia",
          },
          Item4: {
            Question: "Proč nemohu přejít do GrowUP?",
            Answer:
              "Pro přechod do GrowUP musí být splněno několik podmínek:\n• jste přihlášeni pod správným účtem s platnou investiční kvalifikací,\n• klient je propojen s MangoUP,\n• klient má platnou a aktuální kartu klienta (KK),\n• existuje alespoň jeden aktivní cíl,\n• je vyplněný a podepsaný investiční dotazník,\n• u alespoň jednoho cíle je přidáno navrhované řešení.\n\nPokud jsou všechny podmínky splněny a tlačítko je stále neaktivní, nahlaste problém přímo z dané analýzy přes ikonu **Nahlásit problém**. Rádi situaci společně prověříme.",
          },
          Item5: {
            Question: "Proč nemohu upravovat navrhované řešení po sjednání?",
            Answer:
              "Po úspěšném sjednání investice (dokončeno) neexistuje již možnost sjednat další investici v dané verzi analýzy. Pro další sjednání je potřeba vytvořit novou verzi analýzy, tj. označit tuto analýzu za dokončenou a vytvořit z ní novou verzi - stav rozpracováno.",
            ImageAlt: "Ukázka úpravy navrhovaného řešení po sjednání",
          },
        },
        SupportingMaterials: {
          Title: "Podpůrné materiály",
          FinancialPlanning: "Finanční plánování – UPka",
        },
      },
    },
  },
  Validation: {
    Required: "Pole je povinné",
    InvalidEmail: "E-mail je nevalidní",
    InvalidPhone: "Telefonní číslo je nevalidní",
    InvalidFormat: "Neplatný formát",
    InvalidPersonalIdentificationNumber: "Neplatné rodné číslo",
    AssetAllocationSum: "Součet alokace aktiv musí být 100%",
    MustBeOlderThanOneDay: "Datum narození musí být starší než 1 den",
    BirthDateTooOld: "Datum narození nesmí být starší než {{years}} let",
    PercentMax: "Nejvýše 100%",
    MustBeOlderThanDate: "Datum musí být starší než {{date}}",
    BadValue: "Nesprávná hodnota",
    DateMustNotBeFuture: "Datum nesmí být v budoucnosti",
    DateMustNotBeOlderThan14Days: "Datum nesmí být starší než 14 dní",
    DateMustNotBeInPast: "Datum nemůže být v minulosti",
    Number: {
      Min: "Musí být větší nebo rovno {{count}}",
      MinShort: "Min. {{count}}",
      MaxShort: "Max. {{count}}",
      MoreThen: "Musí být větší než {{count}}",
      ZeroOrMoreThan: "Musí být 0 nebo větší nebo rovno {{count}}",
    },
    String: {
      Min: "Nesmí být kratší než {{count}} znaků.",
      Max: "Nesmí být delší než {{count}} znaků.",
    },
    Array: {
      Min: "Musí obsahovat alespoň {{count}} položku.",
      Min_one: "Musí být vybrána alespoň {{count}} položka.",
      Min_few: "Musí být vybrány alespoň {{count}} položky.",
      Min_other: "Musí být vybráno alespoň {{count}} položek.",
    },
  },
  PersonPicker: {
    Placeholder: "Vyberte osobu",
  },
  Table: {
    NextPage: "Další strana",
    PrevPage: "Předchozí strana",
    RowsPerPage: "Řádků na stránku",
  },
  DevTools: {
    Title: "DevTools",
    Tabs: {
      Home: "Home",
      FeatureFlags: "Feature flags",
    },
    Home: {
      BranchName: "Aktuální branch:",
      CommitMessage: "Poslední commit:",
    },
    FeatureFlags: {
      Description: "Zapnuté feature flagy se ukládají do localStorage stejně jako při zapnutí přes URL parametr.",
      EnabledByUrl: "Zapnuto přes URL parametr, dokud je v adrese, nelze vypnout.",
    },
  },
  AppBar: {
    TestEnvironment: "Pozor, jste na testovacím prostředí!",
  },
  UserMenu: {
    Open: "Otevřít uživatelské menu",
    ZfpGroup: "ZFP Group",
  },
  NsureErrors: {
    ClientErrors: {
      PersonalIdentificationNumberNull: "Rodné číslo musí být vyplněno.",
      IdentificationNumberNull: "IČO musí být vyplněno.",
      TypeWrong: "Nesprávný typ klienta.",
      DuplicateFail: "Klient již existuje.",
      PermanentAddressNull: "Klient musí mít alespoň jednu trvalou adresu pobytu.",
      SelfDealingForbidden: "Není dovoleno sjednat smlouvu sám se sebou jako klientem. Vyberte jiného klienta.",
      ConsentsResolved: "Souhlas klienta musí být vyplněný.",
      NotSupportedClientAge: "Sjednávání investic na dítě je možné pouze se zastupující osobou. Zadejte prosím dospělou zastupující osobu.",
      NotSupportedRepresentativeAge: "Zadejte prosím dospělou zastupující osobu.",
      CreateClientFailed: "Klienta se nepodařilo vytvořit.",
      UpdateClientFailed: "Klienta se nepodařilo aktualizovat.",
      ClientMustHaveSignedClientCard: "Klient musí mít podepsanou kartu klienta.",
      ClientTypeCompanyNotEnabled: "Nelze sjednat investice pro právnickou osobu.",
      PhoneNull: "Telefon nebo mobilní telefon je povinný.",
    },
    ContractErrors: {
      EqualManualType: "Nelze zadat jiné než stávající smlouvy.",
      InvestmentHorizonOutOfRange: "Investiční horizont musí být v rozmezí 0–100 let.",
      TypeCanNotChange: "Typ smlouvy nelze změnit.",
      ContractInstrumentsCanNotBeUpdated: "Aktualizace nástrojů na stávajících smlouvách není povolena.",
      ContractCanNotBeUpdated: "Aktualizace stávající smlouvy není podporována.",
      LongtermInvestmentProductOnly: "Typ smlouvy lze vytvořit pouze jako dlouhodobý investiční produkt (DIP).",
      LongtermInvestmentProductUnavailable: "Typ smlouvy nelze vytvořit jako dlouhodobý investiční produkt (DIP).",
      LongTermInvestmentProductNotRelevant: "Věk horizontu nebo klienta není pro DIP relevantní.",
    },
    InvestmentCaseErrors: {
      Null: "Zadejte investici.",
      ClientOutOfRange: "Klient může být zadán pouze jednou.",
      TypeCanNotChange: "Typ investice nelze změnit.",
      CaseIsLocked: "Investice je uzamčena a nelze ji upravit.",
      InvestmentStrategiesEmpty: "Nebyly nalezeny žádné odpovídající investiční strategie.",
      InvestmentCoveragesEmpty: "Nebyly nalezeny žádné odpovídající využití pro cíle.",
      InvestmentAmountsEmpty: "Nebyly nalezeny žádné odpovídající investiční částky.",
      InvestmentContractsEmpty: "Nebyly nalezeny žádné odpovídající smlouvy.",
      MeetingRecordIsMissing: "Záznam z jednání nebyl nalezen.",
      ClientMissing: "Klient není zadán.",
      ClientCanNotBeCreated: "Klienta se nepodařilo vytvořit.",
      CommissionSumExceeded: "Celkový součet provizí nemůže překročit 100 %.",
      CommissionAgentNotSelected: "Zvolte poradce z autocomplete.",
      CommissionAgentNotFilled: "Poradce není vybrán.",
    },
    InvestmentPlanErrors: {
      PaymentEmpty: "Zadejte jednorázovou nebo pravidelnou částku.",
      LongTermInvestmentProductNotRelevant: "Horizont nebo věk klienta není relevantní pro DIP.",
    },
    InvestmentStrategyErrors: {
      OneTimeSumWrong: "Celkové využití vybraných řešení pro počáteční investici musí být rovno {{Sum}}.",
      PeriodicSumWrong: "Celkové využití vybraných řešení pro pravidelnou investici musí být rovno {{Sum}}.",
      ItemsNull: "Chybí investiční nástroje pro strategie.",
      ItemsSumWrong: "Celkové využití investičních nástrojů pro strategii musí být rovno {{Sum}}.",
      ParticipationEmpty: "Není vyplněno procentuální využití pro počáteční ani pravidelnou investici.",
    },
    QuestionnaireAnswerItemErrors: {
      QuestionNull: "Otázka dotazníku neexistuje.",
      QuestionItemNull: "Možnost pro otázku dotazníku neexistuje.",
    },
    QuestionnaireAnswerErrors: {
      QuestionnaireNull: "Dotazník neexistuje.",
      InvestmentPlanNull: "Investiční cíl/pokyn neexistuje.",
    },
    QuestionnaireEvaluationErrors: {
      EvaluationInvestmentPlanEmpty: "Vyhodnocení investičního dotazníku je prázdné.",
      PlanEvaluationTypeNotMatch: "S ohledem na výsledek vyhodnocení investičního dotazníku nelze sjednat žádnou investici.",
    },
    StrategyTemplateErrors: {
      Null: "Je nutno zadat strategii.",
      ItemsNull: "Je nutno zadat strategii.",
      ItemsSumWrong: "Celkové využití vybraných strategií musí být rovno {{Sum}}.",
      AccountGroupItemsNull: "Skupiny účtů jsou vyžadovány pro šablonu typu Skupina.",
    },
    AccessTokenErrors: {
      KeyEmpty: "Chybí přístupový klíč.",
      KeyLength: "Přístupový klíč je neplatný.",
    },
    CaseContractsCreatorErrors: {
      IsNotEnabled: "Investici není možné zpracovat.",
      DocumentSignFail: "Nastala chyba při podepisování dokumentu.",
      ContractDraftFail: "Nastala chyba při vytváření dokumentů k podpisu.",
      ContractFail: "Nastala chyba při vytváření smluv.",
      DocumentSignatureProviderMissing: "Poskytovatel podpisu dokumentů není dostupný.",
      ContractDraftValidationFail: "Chyba při validaci návrhu smlouvy.",
      ContractDraftNotValid: "Návrh smlouvy není platný.",
      ContractDraftIdentificationsValidationFail: "Poradce nemá vyplněno evidenční číslo, není možné sjednat danou smlouvu.",
      FrameworkContractFailed: "Nepodařilo se založit rámcovou smlouvu.",
    },
    CaseContractsValidatorErrors: {
      AgentRequired: "Investice nemá přiřazeného poradce.",
      SignedRequired: "Investici chybí podpis.",
      SessionCloseRequired: "Stav klientské zóny není uzavřen.",
      SignatureRequired: "Podpisy nenalezeny.",
      CaseIsLocked: "Investice je uzamčena.",
      InstitutionContractTypeRequired: "Smlouva nemá vybraný typ.",
      InstitutionTypeRequired: "Smlouva nemá žádného producenta.",
      ActiveInstitutionContractTypeRequired: "Smlouva obsahuje neplatného producenta.",
      ProductOrTariffDisabled: "Produkt z investičního případu není aktivní.",
    },
    ContractEmailErrors: {
      EmailSendFail: "Odeslání emailu klientovi selhalo.",
      CreateContractDraftNotAllowed: "Investice není připravena pro tvorbu dokumentů k podpisu.",
      CreateContractNotAllowed: "Investice není připravena pro tvorbu smluv.",
    },
    DocumentFileErrors: {
      FileNotFound: "Soubor nenalezen.",
      FileNotSupported: "Typ souboru není podporován.",
      FileCanNotBeDeleted: "Soubor nelze odstranit.",
    },
    EntityErrors: {
      InvestmentCaseNotFound: "Investice nebyla nalezena.",
      SessionNotFound: "Klientská zóna nebyla nalezena.",
      ClientNotFound: "Klient nenalezen.",
      SignerNotFound: "Podepisující osoba nebyla nalezena.",
      ContractNotFound: "Smlouva nebyla nalezena.",
      EntityExternalIDNotUnique: "Entita musí mít unikátní identifikátor.",
      ExternalIDNotUnique: "Identifikátor musí být unikátní.",
      NotLoggedUser: "Požadavek není platný pro současného uživatele.",
      InstrumentNotFound: "Investiční nástroj nebyl nalezen.",
      InvestmentCaseContractNotFound: "Smlouva neexistuje.",
      InvestmentCaseTemplateNotFound: "Šablona nebyla nalezena.",
      InvestmentPlanNotFound: "Investiční plán nebyl nalezen.",
      CurrencyNotFound: "Měna nebyla nalezena.",
    },
    CodeErrors: {
      Unspecified: "Nespecifikovaná chyba.",
      OutOfRange: "Chyba v rozmezí.",
      NotFound: "Entita nenalezena.",
      Invalid: "Chyba – neplatný údaj.",
      Forbidden: "Uživatel nemá práva pro vykonání této akce.",
      TooManyRequests: "Pro tuto akci bylo zaznamenáno příliš mnoho dotazů.",
      Conflict: "Chyba – konfliktní údaje.",
      NullOrEmpty: "Chyba – chybějící údaj.",
      Unauthorized: "Uživatel není oprávněn vykonat tuto akci.",
    },
    StrategyPerformanceErrors: {
      Unspecified: "Musí být poskytnut investiční nástroj nebo identifikátor strategie.",
    },
    NotificationErrors: {
      SmsNotAllowed: "SMS služba je vypnutá.",
      SmsResponseFail: "SMS služba selhala.",
    },
    PasswordErrors: {
      AddFail: "Nepodařilo se přidat heslo do cache paměti.",
      VerifyFail: "Heslo je neplatné.",
      TooManyRequestsFail: "Příliš mnoho dotazů na server.",
      EqualFail: "Heslo je neplatné.",
      ExpireFail: "Heslu vypršela platnost.",
    },
    SecurityAccessErrors: {
      AccountNotLogged: "Uživatel není přihlášen.",
      AccountAccessFail: "Aktuální uživatel nemá přístup k investičnímu pokynu.",
    },
    SignatureErrors: {
      WrongStatus: "Požadavek pro podpis lze poslat pouze v nepodepsaném stavu.",
      SignerAlreadySigned: "Požadavek o podpis byl již zaslán.",
      DuplicateSigner: "Duplicitní osoby pověřené podpisem.",
      SignatureRequestNotFound: "Žádost o podpis nebyla nalezena.",
      CreateSignatureNotAllowed: "Podpis investice nelze uskutečnit v průběhu zpracování.",
      SignatureFieldNotFound: "Pole pro podpis nebylo nalezeno.",
      SignFailed: "Proces podepisování dokumentů nebyl úspěšný.",
      SignatureExpired:
        "Platnost návrhu vypršela, dokumenty nelze podepsat. Pokud chcete vytvořit nový návrh, kontaktujte prosím svého poradce.",
    },
    SigSignatureErrorsnature: {
      SignerNotAllowed: "Osoba pověřená podpisem nemá dovoleno podepsat dokumenty.",
    },
    Validation: {
      EmailValidator: "V poli `{{PropertyName}}` není platná emailová adresa.",
      GreaterThanOrEqualValidator: "Hodnota pole `{{PropertyName}}` musí být větší nebo rovna {{ComparisonValue}}.",
      GreaterThanValidator: "Hodnota pole `{{PropertyName}}` musí být větší než {{ComparisonValue}}.",
      LengthValidator:
        "Hodnota v poli `{{PropertyName}}` musí mít mezi {{MinLength}} a {{MaxLength}} znaky. Aktuálně znaků: {{TotalLength}}.",
      MinimumLengthValidator: "Délka hodnoty `{{PropertyName}}` musí mít alespoň {{MinLength}} znaků. Aktuálně znaků: {{TotalLength}}.",
      MaximumLengthValidator: "Délka hodnoty `{{PropertyName}}` musí mít nanejvýš {{MaxLength}} znaků. Aktuálně znaků: {{TotalLength}}.",
      LessThanOrEqualValidator: "Hodnota pole `{{PropertyName}}` musí být menší nebo rovna `{{ComparisonValue}}`.",
      LessThanValidator: "`{{PropertyName}}` musí být menší než {{ComparisonValue}}.",
      NotEmptyValidator: "Pole `{{PropertyName}}` nesmí být prázdné.",
      NotEqualValidator: "Hodnota `{{PropertyName}}` se nesmí rovnat {{ComparisonValue}}.",
      NotNullValidator: "Pole `{{PropertyName}}` nesmí být prázdné.",
      PredicateValidator: "Podmínka pro pole `{{PropertyName}}` není splněna.",
      AsyncPredicateValidator: "Podmínka pro pole `{{PropertyName}}` není splněna.",
      RegularExpressionValidator: "Hodnota `{{PropertyName}}` není ve správném tvaru.",
      EqualValidator: "Hodnota `{{PropertyName}}` se musí rovnat {{ComparisonValue}}.",
      ExactLengthValidator: "Hodnota `{{PropertyName}}` musí obsahovat alespoň {{MaxLength}} znaků. Aktuálně znaků: {{TotalLength}}.",
      InclusiveBetweenValidator:
        "Hodnota `{{PropertyName}}` musí být mezi {{From}} a {{To}} (včetně). Aktuální hodnota: {{PropertyValue}}.",
      ExclusiveBetweenValidator: "Hodnota pole `{{PropertyName}}` musí být mezi {{From}} a {{To}}. Aktuální hodnota: {{PropertyValue}}.",
      CreditCardValidator: "Hodnota pole `{{PropertyName}}` obsahuje neplatné číslo kreditní karty.",
      ScalePrecisionValidator:
        "Hodnota pole `{{PropertyName}}` může mít nanejvýš {{ExpectedPrecision}} celých čísel a {{ExpectedScale}} desetinných míst. Aktuálně obsahuje {{Digits}} čísel a {{ActualScale}} desetinných míst.",
      EmptyValidator: "Hodnota pole `{{PropertyName}}` musí být prázdná.",
      NullValidator: "Hodnota pole `{{PropertyName}}` musí být prázdná.",
      EnumValidator: "Možnosti pro pole `{{PropertyName}}` neobsahují hodnotu `{{PropertyValue}}`.",
      Length_Simple: "Počet znaků hodnoty `{{PropertyName}}` musí být mezi {{MinLength}} a {{MaxLength}}.",
      MinimumLength_Simple: "Hodnota pole `{{PropertyName}}` musí obsahovat alespoň {{MinLength}} znaků.",
      MaximumLength_Simple: "Hodnota pole `{{PropertyName}}` může obsahovat nanejvýš {{MaxLength}} znaků.",
      ExactLength_Simple: "Hodnota pole `{{PropertyName}}` musí mít délku {{MaxLength}} znaků.",
      InclusiveBetween_Simple: "Hodnota pole `{{PropertyName}}` musí být v rozmezí {{From}} a {{To}} (včetně).",
      ExclusiveBetween_Simple: "Hodnota pole `{{PropertyName}}` musí být mezi {{From}} a {{To}}.",
      PositiveNumber: "Hodnota pole `{{PropertyName}}` musí být kladné číslo.",
    },
    CaseAccessErrors: {
      ReadOnly: "Investiční případ je určen pouze pro čtení.",
      OwnerAccountSelected: "Vlastník investičního případu nelze měnit.",
    },
    ForwardCaseErrors: {
      ForwardAccountNotFound: "Uživatel nebyl nalezen.",
      ForwardNotEnabled: "Předávání investičního případu není povoleno.",
    },
    InvestmentJustificationErrors: {
      SuitabilityDateBeforeMeetingDate: "Datum předání smlouvy klientovi nemůže být před datem schůzky.",
      StatementDateBeforeSuitabilityDate: "Datum akceptování/odmítnutí doporučení nemůže být před datem předání smlouvy klientovi.",
    },
    ContractExportErrors: {
      GeneratePidFail: "Aktuálně nelze pro EIC vygenerovat platné PID.",
    },
    ClientInfoErrors: {
      BirthplaceNull: "Místo narození je povinné.",
      LivingAbroadCountryNull: "Země pobytu v zahraničí je povinná, pokud klient žije v zahraničí déle než rok.",
      PepAdditionalInfoNull: "Doplňující informace k politicky exponované osobě jsou povinné.",
      LivingAbroadMoreThanYearNull: "Informace o tom, zda klient žije v zahraničí déle než rok, je povinná.",
      SanctionedByCRNull: "Informace o sankcích České republiky je povinná.",
      SanctionedByCRFalse: "Nelze uzavřít smlouvu pro osobu, na kterou jsou uplatňovány sankce.",
      ClientCountriesError: "Klient musí mít alespoň jednu národnost a jednu daňovou rezidenci.",
      ClientIncomesError: "Je třeba zadat alespoň jeden příjem. U příjmů typu 'Jiný' nesmí chybět specifikace.",
      CountryNationalityNotValid: "Státní příslušnost klienta není platná.",
      CountryTaxResidencyNotValid: "Daňová rezidence klienta není platná.",
      ClientMoneySourcesNull: "Zdroj peněžních prostředků není vyplněn.",
    },
    TakeOverErrors: {
      TakeOverAccessFail: "Převzetí investičního případu se nepodařilo.",
      TakeOverNotEnabled: "Převzetí investičního případu není povoleno.",
    },
    CommonErrors: {
      InvalidInstrumentParticipations: "Neplatná měna podílu v investičním nástroji.",
      LongTermInvestmentProductInvestmentHorizonInvalid:
        "Neplatný investiční horizont. Věk klienta na konci smlouvy musí být vyšší než 60 let.",
      RepresentativeNull: "Zástupce klienta chybí.",
      InstitutionNotSupported: "Instituce není podporována.",
      FeeCalculationFailed: "Pro {{InstitutionType}} se nepodařilo získat vstupní poplatky.",
    },
    ContractInstrumentChangeProposalErrors: {
      BuyCanNotBeNull: "Hodnota pro nákup je povinná.",
      SellCanNotBeNull: "Hodnota pro prodej je povinná.",
    },
    OwnerCaseErrors: {
      OwnerAccountNotFound: "Vlastník investičního případu nebyl nalezen.",
      OwnerAccountSelected: "Vlastník investičního případu nelze měnit.",
    },
    CaseTemplateErrors: {
      InvestmentCaseIDNotSelected: "Investiční případ nebyl vybrán.",
      InvestmentCaseTemplateIDNotSelected: "Šablona investičního případu nebyla vybrána.",
      AtLeastOneSelected: "Musí být vybrána alespoň jedna sekce.",
    },
    InvestmentCaseTemplateErrors: {
      TemplatesNotEnabled: "Šablony nejsou povoleny.",
    },
    ContractInstrumentErrors: {
      InstrumentRestrictionBuyNotAllowed: "Nákup není pro tento nástroj povolen – {{instrumentCode}}.",
      InstrumentRestrictionSellNotAllowed: "Prodej není pro tento nástroj povolen – {{instrumentCode}}.",
      InstrumentRestrictionChangeNotAllowed: "Změna není pro tento nástroj povolena – {{instrumentCode}}.",
      InstrumentRestrictionContractNotAllowed: "Založení smlouvy není pro tento nástroj povoleno – {{instrumentCode}}.",
      InstrumentRestrictionOneTimeNotAllowed: "Jednorázová investice není pro tento nástroj povolena – {{instrumentCode}}.",
      InstrumentRestrictionPeriodicalNotAllowed: "Pravidelná investice není pro tento nástroj povolena – {{instrumentCode}}.",
      InstrumentNotActive: "Nástroj není aktivní – {{instrumentCode}}.",
      InstitutionInstrumentNotActive: "Nástroj instituce není aktivní pro vybraný produkt na smlouvě – {{instrumentCode}}.",
      CustomerInstrumentNotActive: "Nástroj není aktivní – {{instrumentCode}}.",
    },
  },
  zod: translation,
};
